var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491 373",
    style: {
      enableBackground: "new 0 0 491 373"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:#FF9B9D;}\n\t.st3{fill:#119570;}\n\t.st4{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:#16BCFF;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#EF6C56;}\n\t.st8{fill:#FF9DD9;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#FFF039;}\n\t.st11{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st12{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Bike"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66,
    cy: 303,
    r: 49.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66,
    cy: 302,
    r: 4.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "413.2,303 66,303 126.7,203.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.3,42.1c0,9-16.2,30.9-16.2,30.9S169.9,51,169.9,42.1c0-9,7.2-16.2,16.2-16.2 C195.1,25.8,202.3,33.1,202.3,42.1C202.3,42,202.3,42.1,202.3,42.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 186.1,
    cy: 40.9,
    r: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.8,80.5c0,4.8-8.7,16.5-8.7,16.5s-8.7-11.7-8.7-16.5c0-4.8,3.9-8.7,8.7-8.7 C328.9,71.9,332.8,75.8,332.8,80.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 324.1,
    cy: 79.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.1,80.5c0,4.8-8.7,16.5-8.7,16.5s-8.7-11.7-8.7-16.5c0-4.8,3.9-8.7,8.7-8.7S416.1,75.8,416.1,80.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 407.4,
    cy: 79.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.9,42.3c0,9.7-17.5,33.4-17.5,33.4S349.8,52,349.8,42.3c0-9.7,7.8-17.5,17.5-17.5S384.9,32.6,384.9,42.3 L384.9,42.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 367.4,
    cy: 41.1,
    r: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 186.1,
    y1: 73,
    x2: 186.1,
    y2: 102.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Parts_of_bike"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 126.7,
    y1: 203.3,
    x2: 164.3,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.9,303c-17.3-36.5-34.6-73-51.9-109.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 173.9,
    cy: 303,
    r: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.1,287.6c17.1,10.6,34.1,21.2,51.3,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.1,303c-20.7-35.6-41.4-71.2-62-106.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1891 -0.982 0.982 0.1891 -45.7818 550.599)",
    className: "st1",
    cx: 310.5,
    cy: 303,
    rx: 14.1,
    ry: 14.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.1,287.6c17.1,10.6,34.1,21.2,51.3,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,197.3H109c-2.5,0-4.5-2-4.5-4.4c0,0,0,0,0-0.1v-0.4c0-2.5,2-4.5,4.4-4.5c0,0,0,0,0.1,0h27.9c2.5,0,4.5,2,4.5,4.4 c0,0,0,0,0,0.1v0.4c0.1,2.4-1.9,4.4-4.3,4.5C137,197.3,137,197.3,136.9,197.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Woman_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.8,117l8.4,21.2c3.9,9.7,14.4,15,24.5,12.2l37.9-10.8L181,123.5l-28.9,1.9c-1.3-9.1-2.7-18.1-4-27.3 l-7.6,1.5C133.8,105.3,127.3,111.2,120.8,117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,123.6l-9.9-7.3c-1.1-0.8-1.3-2.3-0.5-3.4c0,0,0,0,0,0l18.6-25c0.8-1.1,2.3-1.3,3.4-0.5c0,0,0,0,0,0l9.9,7.3 c1.1,0.8,1.3,2.3,0.5,3.4c0,0,0,0,0,0l-18.6,25C185.4,124.2,183.9,124.4,182.8,123.6C182.8,123.6,182.8,123.6,182.8,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.6,96.9c1.6-0.3,3.2,0.7,3.6,2.2c0.3,1.2,0.6,2.5,0.9,3.9c0.5,2.4,0.9,4.7,1.1,7.1l1.4,8.8 c1.7,9.8-5,18.6-14.7,21.1c-7.1,2.2-9.1-1.5-16.1,0.7c-5.6-7.1-16.3-8.4-21.9-15.6c10.3-0.6,20.7-1.2,31-1.9l-4.5-7.2 c-0.3-1.9,0.4-3.4,1.8-4c2.1-0.9,4.5,0.1,5.3,2.2c0.1,0.2,0.1,0.4,0.2,0.5l2,2.3l2.4-2.5l-5.1-4.8c-0.2-0.2-0.4-0.4-0.5-0.6 c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.8,0.3-1.5,0.8-2c0.4-0.4,0.8-0.6,1.3-0.8c0.9-0.2,1.8,0,2.5,0.5l2.5,1.2l5,2.5 c-0.4-3-0.9-5.8-1.3-8.8C194.9,98.7,196,97.2,197.6,96.9L197.6,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.9,124l0.3-0.3c1.4-1.5,1.4-3.7,0-5.2l-3.9-4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 196.5,
    y1: 109.1,
    x2: 200.1,
    y2: 111.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,262.3c-5.1,13.6-10.3,27.1-15.4,40.8c9.6,0.1,19.2,0.1,28.7,0.2l62.4-0.1c2.4,0,4.3-2,4.2-4.4 c0-2.1-1.6-3.9-3.7-4.2l-14.3-1.5c-16.6-1.8-29.8-14.6-32-31.1l0,0C227.3,262,217.3,262.1,207.3,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.5,289.1c-20.5,0.2-45,0.3-65.4,0.5c1.8-30,9-79.3,10.7-109.2c-13,20.3-28.3,34-45.1,42.8h-0.1 c-0.2-16.9-0.3-33.8-0.5-50.8c0.1,0.1,0.2,0.1,0.3,0c0,0,0,0,0,0c13.7-7.1,27.4-14.2,41.1-21.3c12.2-4.2,24.5-8.5,36.7-12.6 C248.1,182.2,254.5,245.3,262.5,289.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,298.7c0,2.4-1.9,4.3-4.3,4.3l-62.4,0.1c-9.6-0.1-19.2-0.1-28.7-0.2c5.1-13.6,10.3-27.1,15.4-40.8 c7.2-0.1,14.5-0.3,21.7-0.4c2.8-0.1,5.5-0.1,8.3-0.2c1.6,12.2,9.3,22.7,20.4,27.9c3.7,1.8,7.6,2.9,11.6,3.3l14.3,1.5 C209.6,294.7,211.1,296.6,211.2,298.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.4,289.6c-22.5-0.2-45.1-0.3-67.7-0.5c13.4-25.5,36.4-69.9,49.7-95.4h-15.9c-14.5-0.2-28.8-0.3-43.3-0.5 c-5.2-2.1-9.6-5.8-12.4-10.7c-2.7-4.9-2.8-9.5-2.8-15.3c0-4.2,1-6.9,1.6-10.8c0.6-3.8,3.4-6.8,7-7.7c2.1-0.5,3.9-1.4,7-2.4 c5-1.6,10.2-2.6,15.4-3.3c5.6-1.1,11-2.7,16.2-5c-1.4,4.3-3,8.6-4.5,12.8c0.1,0,0.1,0.1,0.2,0.1c17.8-2.8,35.7-5.4,53.6-8.2 c16.8-2.6,32.4,9,35,25.8c0.7,4.7,0.3,9.6-1.2,14.1C213.1,211.8,194,260.2,184.4,289.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 207.2,
    y1: 229.3,
    x2: 222.4,
    y2: 182.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.6,75.8c0,0.4,0,0.9-0.1,1.3c0,0.3,0,0.5-0.1,0.8c-0.1,1.2-0.4,2.3-0.7,3.5v0.2c0,0.1-0.1,0.3-0.1,0.4 c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.8-0.6,1.6-1,2.3c-0.8,1.2-1.9,2.3-3.2,3.1c-2.2,1.3-4.6,1.9-7.1,1.7c-3.1-0.2-6-1.3-8.5-3.3 l-8.9-1.9l-2-0.4c-2.7-2.8-2.1-8.8-2.1-8.8c-0.4-1-0.4-2.1-0.1-3.1c1.1-2.9,1.5-4.7,2.2-5.6c2.2-2.6,5.2-4.4,8.6-5.1 c2.8,0,10.5-1.9,16.4-0.6c0.6,0.1,3.6,1.2,4.3,2.2c0.7,1,0.2,1.1,0.5,2.8c0.1,0.5,0.1,0.7,0.3,0.9c0.2,0.1,0.5,0.2,0.7,0.2 c0.9,0,1.3,0.9,1.5,1.3C132.2,70.4,130.7,74,130.6,75.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 113.1,
    y1: 88.9,
    x2: 106.7,
    y2: 96.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.8,87.9c-0.1,3-0.3,5.9-0.4,8.8h-14.5c0.3-4.7,0.4-9.9,0.7-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,77.5l5.2-0.1c-1.3-1.4-2.8-2.9-4.1-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.5,82.3c-0.2,0.4,0.3,1.1,1,1.3c1,0.3,2-0.8,1.8-1.2C124.2,81.8,121.8,81.6,121.5,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.5,88.8c1.8,0.6,3.6,1,5.5,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,76.5c0,0,3.6-3.8,6.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.1,60.7c1,1.9,2.7,3.3,4.7,4.1c1.4,0.5,3,0.6,4.5,0.3c-2.2-0.1-7.3,2.9-13.1,3.1 c-3.3,1.9-6.1,4.5-8.2,7.6c-1-1.6-2.1-3.3-3.2-4.8l0,0c-3.9-0.3-4.8-0.2-6.2,0.4c-2.2,0.9-2.8,4-2.9,4.4c-0.5,3.7,2,7.1,5.7,7.7 c0.4,0.1,0.8,0.1,1.1,0.1c0.5,0.1,1.1,0.1,1.6,0.2c0.1,5.4,2.8-3.7-1.9,7.1c-7.3-8.1-10.7-19-4.1-25.3c2.2-2.3,5.1-4,8.3-4.6 c0,0,1-0.1,3.1-0.2c1.8-0.2,3.5-0.2,5.3-0.1C117.6,60.6,119.3,60.6,121.1,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.5,72.1l-0.3,1c-0.3-0.9-12.8-4.6-14.1-4.9c-0.2-0.2,5-3.8,4.8-4.1c-0.5-1-0.6-2.2-0.4-3.4 c0.7,0.1,1.4,0.1,2.1,0.2l0,0c0.3,0.1,0.6,0.1,0.9,0.2c2.4,0.6,4.4,2,5.7,4.1c0.2,0.3,0.3,0.5,0.5,0.8l0,0 C131.9,67.9,132.1,70.1,131.5,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.2,76c0,0,4.1-4.3,6.6,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,76.5c-0.3,0.5-0.4,1.1-0.5,1.6c-0.1,0.9-0.1,1.8,0.1,2.8c-1-0.2-2-0.6-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.5,76.7L119.5,76.7c0.5-0.1,0.7-0.4,0.6-0.8v-0.1c-0.1-0.4-0.4-0.6-0.8-0.6h-0.1c-0.4,0.1-0.6,0.4-0.6,0.8v0.1 C118.7,76.6,119.1,76.8,119.5,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.3,101.2c10-2.5,11-3.2,21-5.7l24.8-6.4c4.4,19.3,17.6,56.3,22,75.5c-16,5-44.1,20.9-60.8,23.1 c-2.7-11.4-6.6-56.5-9.5-68.2C83.3,113.2,89,107.5,87.3,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M159.7,124.6L145.6,149l-27-56.1l14.4-4.2c10.2-3.1,21,2.7,24.1,12.9c0.4,1.2,0.6,2.4,0.7,3.7 C158.3,110.9,159.1,119.1,159.7,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.7,215.2c0.4,2.1,2.5,3.5,4.6,3c0.3-0.1,0.5-0.1,0.8-0.3c1.2-0.5,2.1-1.6,2.2-3l0.1-0.3 c0.7,1.5,2.4,2.3,4,1.9l1.8-0.5c1.1-0.3,2-1.1,2.3-2.1l0.1-0.4v-0.7c0.2,2.3,2.2,4,4.5,3.8c0.3,0,0.5-0.1,0.8-0.1 c1.8-0.5,3-2.2,3-4.1l0.2-11.9l0.5-0.6c1.6-1.8,2.2-4.3,1.7-6.6l0,0c-0.1-1.2-0.6-2.2-1.4-3.1c-1.9-1.6-4.5-1.9-6.7-0.8 c-0.7-3.7-1.8-3.3-2.5-6.9c-7,2.8-14.4-1.5-21.4,1.2C136,193.1,138.2,205.6,139.7,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.8,213.1c-0.2-2.9-0.5-5.7-0.7-8.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 147.6,
    y1: 205,
    x2: 147.5,
    y2: 214.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.1,200.4c-0.1-1.5-0.1-3.1-0.2-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.1,188.8c-13.5-13.3-27-26.5-40.5-39.8c-11.6-16.3-19.9-29.1-31.5-45.4c-4.2,0.4-8.2,2.2-11.3,5.1 c-6.4,6.4-9.4,15.4-1.7,26.8c8.9,9.4,17.6,18.8,26.5,28.1c13.5,11.5,26.8,23,40.3,34.6C149.9,195.1,156,191.9,162.1,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.2,171.5l32.7-19.9l-30.6-55.1c-4.8,1.5-17.8,4.8-22.6,6.3c-10.2,3.2-15.8,14.1-12.6,24.3 c0.4,1.2,0.9,2.4,1.5,3.5C73.4,135.6,99.6,166.7,102.2,171.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 129.2,
    y1: 155.8,
    x2: 98.5,
    y2: 111.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,77.2L129,77.2c0.5-0.1,0.7-0.4,0.6-0.8v-0.1c-0.1-0.4-0.4-0.6-0.8-0.6h-0.1c-0.4,0.1-0.6,0.4-0.6,0.8v0.1 C128.3,77.1,128.6,77.3,129,77.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.9,127.5c2.1-0.8,3.2-3.3,2.4-5.4c-0.6-1.6-2.2-2.7-3.9-2.7H382c1.4-1,2-2.9,1.3-4.5l-0.8-1.8 c-0.5-1.1-1.5-1.9-2.7-2.1l-0.4-0.1l10.1-2.7c2.4-0.6,3.8-3,3.2-5.4c-0.1-0.3-0.2-0.6-0.3-0.8c-0.9-1.8-2.9-2.8-4.9-2.4l-23.3,4.6 l-0.7-0.4c-2.2-1.3-4.9-1.5-7.2-0.6l0,0c-1.2,0.4-2.2,1.1-3,2.1c-1.3,2.3-1.2,5.1,0.3,7.2c-3.8,1.4-7.4,2.9-11.2,4.4 c4.2,6.8,5.3,15,9.5,21.9C361.4,135.4,374.1,130.9,383.9,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.8,105.3l5.5,6.4c1.2,1.5,1.1,3.6-0.2,5l0,0c-1.5,1.4-3.9,1.3-5.3-0.2c0,0,0,0,0,0l-5-5.5l2.7,4 c0.8,1.3,0.7,2.9-0.3,4.1l-0.7,0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 378.9,
    y1: 111,
    x2: 370.7,
    y2: 112.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.3,117.1c0.1,0,0.3,0.4,0.5,0.9c1.1,2.2,3.5,3.5,5.9,3.1l10.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,120.9l-1.3,0.9c-1.1,0.7-1.6,2.1-1.1,3.4l0,0c0.4,1.2,1.6,2,3,1.9l6.9-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.8,89.7c0.4,0,4.6-0.1,7-0.1h5.2c7.3-0.1,14.6-0.1,21.7-0.1c0.8,0,1.5,0.1,2.2,0.2 c10.6,1.4,22.2,17,30,29.3c10.8-2.2,21.6-4.4,32.4-6.6c3.6,9.7,7.1,19.3,10.7,28.9l-39.8,11.8c-3.5,1-7.3,0.5-10.4-1.4 c-8.4-5.2-16.6-10.5-25-15.7c0.8,0.3,1.7,0.5,2.5,0.6c-11.5,1-23.2,2.1-35.1,3.5l-10.4,1.2C242.8,128.7,245.8,90.2,250.8,89.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M287.4,136.8c0.8-7.6,1.6-15.2,2.3-22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M439.9,258.6c-11.6-6.6-43.2-25.5-54.7-32.1c4.2-6.4,8.4-12.7,12.5-19.2c10.7-16.3,6.6-38.2-9.4-49.4 c-0.1-0.1-0.3-0.2-0.4-0.3c-9-6.3-18.2-6.5-23.2-6.6c-8.9-0.2-37.5,1.9-77.2,7.2l1.8-30.3c-7.4,4.4-15.2,7.8-23.4,10.2 c-9.2,2.7-19.5,5.3-24.1,7.4c-12.6,6.1-10.6,23.6-4,37.6c1.4,3.3,3.6,6.3,6.5,8.5c0.1,0,51.3,31.3,72.8,45.9 c-2.8,3.1-24,25.2-26.7,28.2c14.8,9.3,31.4,18.5,46.2,27.8c1.9-3,20.4-24.7,22.3-27.6c11.4,7.7,42.7,27.7,54.1,35.5 C422.1,287.2,431,272.9,439.9,258.6z M327.8,193.8c9.6,0.1,19.2,0.2,28.6,0.2c-3.2,3.6-6.4,7.1-9.6,10.6 C340.6,201.1,334.2,197.4,327.8,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,319.1l-11.1-8.9c-12.9-10.4-19.1-15.5-22-21.4l-12.6-7.1c-10.9-6.6-15.4-9-26.3-15.6c-9.6,10-0.9,1-10.6,10.9 c6.5,4,12.9,8.1,19.5,12l2.7-3.8c0.9-1.6,2.7-2.4,4.5-1.8l0,0c2,0.6,3.2,2.7,2.6,4.8c-0.1,0.3-0.2,0.6-0.4,0.9l-3.5,3.7l52.4,33.2 c2,1.3,4.6,0.7,5.9-1.3C364.8,322.9,364.4,320.4,362.7,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.7,225.7c-1.8-1.2-4.2-0.8-5.6,0.8l-9.1,10.9c-10.6,12.7-10,18.2-23,21.2l0,0c-5.9,9.6-17.4,28-23.3,37.7 c5.8,7.2,2.8,3.2,11.9,12.1c4.1-6.4,8.3-12.8,12.3-19.3l-3-2c-1.6-0.9-2.5-2.1-2-3.9l0,0c0.7-2.1,3-3.2,5-2.4 c0.2,0.1,0.4,0.2,0.7,0.3l3.1,2.1l34-51.8c1.3-1.8,1-4.3-0.8-5.6C477.8,225.8,477.7,225.7,477.7,225.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 312.8,
    y1: 193.8,
    x2: 326.9,
    y2: 193.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.8,218.2c3.2-3.7,6.3-7.3,9.6-11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.6,264.4c4.1-5.8,8.1-11.6,12.1-17.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 413.2,
    cy: 303,
    r: 49.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 413.2,
    cy: 303,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.2,303c-19-45.5-37.9-91.1-56.8-136.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.7,149l23-5.1c3.9-0.8,8,0.6,10.6,3.6l13.9,15.1c2.1,2.4,5.1,3.7,8.3,3.8h6.8c6.6,0,12-6.1,12-13.6l0,0 c0-7.1,4.8-12.9,11-13.6l32.6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.4,137.6v-0.5c-0.1-1.3-1.3-2.3-2.7-2.2l-20.1,1.6c-1.3,0.1-2.3,1.3-2.2,2.7v0.5c0.1,1.3,1.3,2.3,2.7,2.2l20.1-1.6 C416.5,140.2,417.5,139,417.4,137.6C417.4,137.7,417.4,137.6,417.4,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,144.8c-0.4-1.3-1.7-2.1-3.1-1.7l-19.4,5.4c-1.3,0.4-2.1,1.7-1.7,3.1l0.1,0.5c0.4,1.3,1.7,2.1,3.1,1.7l19.4-5.4 c1.3-0.4,2.1-1.7,1.7-3.1L298.6,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M312.1,166.5c-0.2-1.9-0.5-7-1-14l-1-8.9c-1-9.9-9.9-16.5-19.9-16.4l-19.4,0.3c-1.1,7.6-2.2,15.3-3.4,23 c6.8-1.7,13.7-3.6,20.5-5.3l-2.3,8.2c0,2,1.7,3.7,3.7,3.7c2,0,3.7-1.7,3.7-3.7c0-0.2,0-0.4-0.1-0.6l1.3-2.9l3.1,1.8l-3.6,6 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.5-0.1,1,0,1.4c0.2,0.7,0.7,1.4,1.3,1.8c1.3,0.7,2.9,0.4,3.8-0.7l2.1-1.9l4.1-3.8l1.4,11.7 c0,0.8,0.4,1.5,1,2c1.4,1,3.9,0,4.6-1.3C312.1,167.4,312.2,167,312.1,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.4,141.8l0.4,0.2c1.7,1,2.3,3.2,1.3,5l-2.7,4.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 305,
    y1: 155.3,
    x2: 307.5,
    y2: 151.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M257.7,89.6h-14.6c-7,0-13.5,3.7-17.1,9.7c-6.2,10.3-11.6,21.1-16,32.3c-1.4,3.7-2.9,7.3-4,10.9 c-1.4,3.9-1,8.1,1,11.7c0.5,0.9,1.2,1.7,1.8,2.5c5.4,6,13.5,4.7,14,4.6l47.2-0.6l0.5-38.2l-22.5,2.4c-0.8,0.1,8.5-1.6,12.6-7.1 C265.6,111.1,262.6,100,257.7,89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M247.8,118.3c-1.1,3.8-2.3,7.5-3.6,11.2c4-0.1,8-0.2,12-0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.6,139.3c-0.1,0.2-0.2,0.3-0.2,0.4c0-0.1,0,0,0.1,0s0,0.2-0.1,0.2c0,0.2,0.1,0.1,0.1,0.2V140h-0.1 c0.1-0.2,0.2,0,0.2-0.2v-0.1l0.1-0.1h-0.1l0.1-0.1c-0.1,0,0.1-0.1-0.1,0V139.3c0.1-0.1,0.2-0.1,0.2-0.2V139l-0.1,0.1l-0.1,0.1 V139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,135.6l0.1-0.1C211,135.6,211,135.6,211,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.8,135.7c0.1,0,0.1-0.1,0.2-0.2L210.8,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,135.3c0.1-0.1,0.1-0.3,0.2-0.2h-0.1l0.1-0.2l-0.1,0.1c0,0.1-0.2,0.3,0,0.2L209.7,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,139.5l0.1,0.1l-0.1,0.1h0.1v0.2l0.1-0.1c0,0.1,0,0.1-0.1,0.1l0,0c0.1,0.1,0,0.1,0.1,0l0,0 c0-0.1,0.1,0,0.1-0.2l0,0v-0.2h0.1v-0.1c0-0.1,0-0.1,0.1-0.1l0,0h-0.1v-0.1c0,0.1,0,0.1-0.1,0.2 C211.8,139.7,211.8,139.3,211.8,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212,140.2c0-0.1-0.1,0-0.1-0.1c0-0.1-0.1,0,0,0.1S212,140.3,212,140.2L212,140.2c0.1,0,0.1,0,0.2-0.1 c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l0,0C212.1,140,212.2,140.2,212,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,135.9L211.3,135.9l-0.1-0.1h0.1c-0.1-0.1-0.1,0.3-0.2,0.1v0.1C211.2,135.8,211.2,136.2,211.3,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,136.7L211,136.7L211,136.7L211,136.7c0.1-0.2,0.1,0.1,0.1-0.1C211.1,136.5,211.2,136.7,211,136.7 c0.1,0.2,0.1,0.2,0.2,0.1v-0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0.1,0,0-0.2,0.1-0.3h-0.1c0.1,0,0,0.1,0,0.1h-0.1l-0.1,0.1H211 l0.1-0.1H211v0.1c-0.1,0,0-0.1,0-0.1s0,0.2-0.1,0.2h0.1c0,0.1-0.1,0.1-0.1,0.2C210.9,136.6,210.9,136.8,211,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,136c-0.1,0.1-0.1,0-0.2,0.2c0.1,0,0.1,0,0.2-0.1V136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,137v-0.1l-0.1,0.1H211.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.8,140 211.9,140.1 211.9,140  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.5,136.7c0-0.1,0-0.2,0.1-0.3c0,0.1-0.1,0.1-0.1,0.2C210.5,136.6,210.5,136.7,210.5,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,136c0,0.1,0,0.2-0.1,0.3c0-0.1,0.1-0.1,0.1-0.2V136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,136.6c0-0.2,0.2-0.4,0.2-0.5l0,0c0-0.1,0-0.1,0.1-0.2c-0.1,0.2-0.2,0.3-0.3,0.5L210.7,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,135.7c0.1-0.1,0-0.1,0.2-0.1h-0.2C210.6,135.7,210.6,135.7,210.7,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,140.7c-0.1,0.1,0,0.2,0,0.3l0.1-0.1l0.1,0.1v-0.2h0.1v-0.1l0.1-0.1c-0.1,0-0.1,0.1-0.2,0.1l0,0 l-0.1,0.1v0.1c0,0-0.1-0.1-0.1,0V140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,140c0-0.1-0.1,0,0-0.1V140L211.7,140c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0L211.7,140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,140.5c0,0.1,0,0.1-0.1,0.1l0,0C211.6,140.6,211.7,140.5,211.7,140.5L211.7,140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,139.4v-0.1c0-0.1-0.1,0-0.1,0v0.2C209.6,139.4,209.6,139.3,209.7,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.4,139.2c-0.1,0.1-0.1,0.4-0.2,0.5c0.1,0.1,0,0.3,0.1,0.3l0,0c0.1,0,0,0.1,0,0.1c0.1-0.1,0.1-0.2,0.1-0.3 c0.1,0,0,0.2,0,0.2c0,0.1,0,0.1-0.1,0.1l0,0h0.1c0-0.1,0.2-0.3,0.1-0.4c-0.1-0.1,0,0.1-0.1,0.1v-0.3l-0.1,0.1v-0.3L209.4,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,137.2c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0,0-0.1,0-0.1s-0.2,0-0.3,0.1c0.1,0.1-0.1,0.2-0.1,0.2l0.1-0.1 l0,0c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2,0c0,0,0,0,0,0v0.1h-0.1c0,0.1,0,0.2-0.1,0.2l0,0l-0.1,0.3v0.1l0.1-0.1v0.2 c-0.1,0-0.1,0.2-0.2,0.2l0,0v0.1c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0-0.1,0.1-0.2v0.2c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0 c0-0.1,0-0.2,0.1-0.2v0.1c0-0.1,0-0.1,0.1-0.1l0,0h-0.1c0.1-0.1-0.1-0.1,0-0.2l0.1,0.1l0,0v0.1c0,0.1,0,0.1-0.1,0.1l0,0l0,0v0.1 l0.1-0.1c-0.1,0.2,0.1,0,0,0.2c-0.1,0-0.1-0.1-0.2,0c0.1,0,0,0.2-0.1,0.3l0,0l-0.1,0.2h0.1c0.1-0.1,0-0.1,0.1-0.2v0.2l0.1-0.1 l-0.1,0.2c0.1,0,0,0.1,0,0.2c0-0.1,0-0.1,0.1-0.1l0,0l0,0c0,0,0.1-0.1,0-0.1s0,0.1-0.1,0c0-0.1,0-0.1,0.1-0.1l0,0l0,0 c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.4,0.3-0.3c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.1-0.3,0.1-0.5c0.1-0.1,0.1,0,0.2-0.2 c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2,0,0.2-0.2c0,0.1-0.1,0-0.2,0s0.1,0,0.1-0.1s-0.1-0.1-0.2,0.1l0,0c0,0.1-0.1,0.3-0.1,0.4 C210.3,137.3,210.4,137.1,210.3,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.8,139.3L209.8,139.3c-0.1-0.2,0.1-0.1,0-0.3c0,0.2-0.2,0-0.2,0.2C209.6,139.4,209.8,139.3,209.8,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.1,135l-0.1,0.1v0.2C210,135.2,210.1,135.1,210.1,135z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.1,141.9L212.1,141.9c0,0,0.1-0.1,0-0.1V141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,137.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,137.8c0.1,0.1,0.1-0.1,0.1-0.1v-0.1c0.2,0,0.1-0.2,0.2-0.3l0,0c-0.1,0.1-0.2,0.1-0.3,0.3L210.3,137.8 L210.3,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.6,137.4L210.6,137.4c0-0.1,0-0.1,0.1-0.1l0,0L210.6,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,141.2v-0.1C211.7,141.1,211.7,141.2,211.8,141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,140.2c0-0.1,0-0.1-0.1-0.1l0,0c0,0.1,0,0.1-0.1,0.1l0,0C211.1,140.3,211.2,140.1,211.2,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,141.4C211.6,141.4,211.6,141.2,211.5,141.4L211.5,141.4l0.1-0.2C211.6,141.2,211.5,141.3,211.5,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,143.8c0-0.1,0-0.1,0.1-0.1l0,0h-0.1c0.1-0.1,0-0.1,0.1-0.1l-0.1-0.1c0.1,0,0.1,0.1,0.2,0v-0.2 c0-0.1,0,0.1-0.1,0c-0.1-0.1,0.2-0.2,0.2-0.4l0,0c0-0.2,0.2-0.2,0.1-0.4h-0.1c0.1-0.1,0-0.2,0.1-0.3l0,0v0.1c0,0.1-0.1,0.2-0.1,0.3 l0,0c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.1l0,0l0.1,0.1c0,0,0,0.2-0.1,0.2c-0.1,0,0.1-0.3-0.1-0.3c-0.1,0.1-0.1,0.1-0.1,0.2 l0.1-0.1c0,0.1,0,0.2-0.1,0.2h0.1c0,0.1-0.1,0.1-0.1,0.2h0.1v0.1l-0.1,0.1C211.5,143.8,211.6,143.7,211.6,143.8L211.6,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.2,137.2c-0.1,0,0-0.1,0-0.1l0,0V137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,141.1L211.1,141.1l0.1-0.1C211.2,141,211.1,140.9,211.1,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,142.2L211.6,142.2c0-0.1,0-0.1,0.1-0.1l0,0h-0.1V142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,142.3L211.8,142.3l-0.1,0.1L211.8,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,139.7L210,139.7v0.2c-0.1-0.1,0.1-0.2,0-0.3h0.1v-0.1c0,0,0-0.2,0.1-0.2s0,0.2,0.1,0.1v-0.2h0.1 c0.1-0.1-0.1-0.2,0.1-0.2c0-0.2,0.1-0.3,0-0.4l0,0c0,0.1,0,0.1-0.1,0.1l0,0v-0.2c0,0.1-0.1,0.3-0.2,0.4h0.1c0,0.2-0.1,0-0.1,0.2 c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0.1-0.1,0-0.1,0.1h0.1c0,0.2,0,0.2-0.1,0.3C209.9,139.7,210,139.5,210,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,141.9L211.5,141.9c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0L211.5,141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,141.6c0.1,0,0-0.1,0.1-0.1v-0.1L211.1,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,142c0,0,0.1,0.1,0.1,0H210.9c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0.2,0,0.1,0.1l0.1-0.2 c0,0.1-0.2,0.1-0.2,0.1L210.9,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,137.4L210,137.4C209.9,137.5,209.9,137.4,210,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.2,134.9L209.2,134.9c0,0.1,0.1,0.1,0.2,0.1v-0.1l0.1-0.1h-0.1l0.1-0.2c0,0.1-0.1,0-0.2,0.2v-0.1 L209.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,141.6C211.1,141.5,211.2,141.5,211,141.6C211.1,141.6,211,141.5,211,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,142.7v-0.1h0.1v-0.1l0,0C211.6,142.7,211.5,142.5,211.5,142.7C211.4,142.5,211.4,142.7,211.5,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,141.9v0.2c-0.1,0.2-0.1,0-0.2,0.2h0.1v0.1c0-0.1,0,0,0.1,0c0.1,0-0.1-0.3,0.1-0.4 C211.4,141.9,211.2,141.9,211.1,141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,139.5C210.2,139.5,210.3,139.3,210.3,139.5c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0L210.3,139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,135.3c0,0.1,0,0.2-0.1,0.2C209.6,135.5,209.7,135.4,209.7,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.5,135.3l-0.2,0.1C209.4,135.5,209.5,135.4,209.5,135.3v0.1C209.6,135.5,209.5,135.3,209.5,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.4,135.3l-0.1,0.1v0.2C209.3,135.5,209.3,135.4,209.4,135.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.6,136.2 209.6,136.2 209.4,136.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,142.9v-0.1c-0.1,0-0.1-0.1-0.1,0C211.5,142.8,211.5,142.8,211.5,142.9 C211.5,142.9,211.5,142.9,211.5,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,142.8l0.1-0.1C211.4,142.6,211.4,142.7,211.3,142.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.8,141.7 210.8,141.6 210.7,141.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,136.9L209,136.9c0,0.1,0.1,0,0,0.1l0.1-0.1H209c0.1-0.1,0.2-0.2,0.3-0.3l0,0c0-0.1,0.1-0.1,0.1-0.2 C209.3,136.5,209.2,136.8,209,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,136.9L208.9,136.9c-0.1,0.1-0.1,0.1,0,0.1c0.1,0,0-0.1,0.1-0.2L208.9,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,136.8c0-0.1,0.1-0.2,0-0.1l0.1-0.2c0.1,0,0.1-0.1,0.1-0.2l0,0c0.1-0.1,0.1-0.2,0.1-0.3h-0.1 c0-0.1,0-0.1,0.1-0.2h-0.1c-0.1-0.1,0.1-0.1,0-0.2c-0.1,0.1-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.3-0.2,0.4h0.1l-0.1,0.1h0.1 c0,0.1,0,0.1-0.1,0.1l0,0c0,0.1,0,0.1-0.1,0.2l0.1-0.1l0,0C208.9,136.8,209,136.7,209,136.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.9,142.3 211,142.2 210.9,142.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.6,139l0.1,0.1V139C209.7,139,209.7,138.9,209.6,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.1,135.1c0-0.1,0.1-0.1,0.1-0.2h-0.1C209.1,135,209,135.1,209.1,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,135.3l-0.1,0.1c0,0.1,0.1,0.1,0.1,0l0,0V135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,135.6c0.1-0.1,0.2-0.3,0.1-0.3v0.1l0,0C209.1,135.6,208.9,135.6,209,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,135l-0.1,0.1C209,135.2,209,135,209,135z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.8,143.8 211.7,143.9 211.8,143.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,135.8L209,135.8c0-0.1-0.1,0-0.1-0.1l-0.1,0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2 C208.8,136,208.9,135.9,209,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.8,135.6L208.8,135.6C208.9,135.6,208.8,135.6,208.8,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,137.5c0.1-0.3,0.4-0.4,0.4-0.7c0.1-0.1,0.2-0.1,0.3-0.3v-0.1l-0.2,0.2l0.1-0.1c0,0-0.1,0.1-0.1,0 c0-0.1,0-0.1,0.1-0.1l0,0h-0.1c0.1-0.1,0.1,0,0.2-0.1h-0.1c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.2-0.3l0,0c0.2-0.2-0.1-0.1,0.1-0.3 c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0l0,0v0.1c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.2-0.2,0-0.2,0.3c0,0.3-0.3,0.5-0.3,0.7l0,0 c0,0.1-0.1,0.2-0.2,0.3h-0.1v0.2l0.1-0.1L207.7,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,136.5c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0h0.1v-0.2c0,0.1-0.1,0.1-0.2,0.2l0,0V136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,136.4l-0.1,0.1L208.5,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,143.4L211,143.4C211.1,143.4,211,143.5,211,143.4l0.1,0.1v0.1h0.1c0-0.1,0-0.2,0.1-0.3h-0.1 c0,0-0.1-0.1-0.1,0v0.1C211.1,143.3,211,143.4,211,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,142.2c0-0.4,0.2-0.5,0.3-0.8l0.1,0.1c0-0.1,0.2-0.1,0.1-0.4c0-0.1,0-0.3,0.1-0.4l0,0c0.1-0.1,0-0.2,0-0.3 h0.1c0-0.1-0.1,0-0.1,0s-0.1,0.2-0.1,0.4c-0.1-0.1,0.1-0.2,0-0.3c-0.1,0.1,0,0.3-0.2,0.4c0,0,0.1-0.1,0.1,0c0,0.1,0,0.2-0.1,0.3 h0.1v0.3c-0.1,0-0.1,0.2-0.2,0.3c0.1,0,0,0.1,0,0.2C209,142,208.9,142.1,209,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,138.2v-0.1C208.9,138.2,208.9,138.2,209,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.8,137.2L208.8,137.2c0,0-0.2,0.2-0.2,0.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.1,0,0-0.1-0.1,0l0,0 c-0.1,0.2-0.1,0.1-0.2,0.2c-0.1,0.1,0.1-0.2,0-0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.2-0.4,0.1-0.6h-0.1v0.2c-0.1,0.2-0.2,0.4-0.3,0.6 h0.1c-0.1,0.1-0.2,0.2-0.2,0.1c0-0.1,0-0.1,0.1-0.2c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0v0.1l0,0c-0.1,0.1,0,0.1,0,0.2h0.1 c0,0.1,0,0.1-0.1,0.1l0,0l0,0c0,0.1-0.1,0.1-0.1,0.2c0.2,0,0.1-0.3,0.2-0.4l0,0c0,0.1,0,0.1-0.1,0.1l0,0c0,0,0.1,0.1,0,0.1h-0.1 c0,0,0,0.2-0.1,0.2l0,0c-0.1,0.2-0.1,0-0.2,0.1h0.1l-0.1,0.2l0,0c0,0,0,0.2,0.1-0.2h0.1v-0.1c0.1,0.1,0.1-0.3,0.2-0.4l0,0 c0.2-0.2,0.2-0.1,0.3-0.3c0,0.1,0,0.1,0.1,0.1v-0.1C208.8,137.5,208.7,137.3,208.8,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,143c0-0.1,0-0.1,0.1-0.1l0,0C208.5,142.9,208.5,142.9,208.5,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.4,141.8c0.1,0,0-0.1,0.1-0.2L207.4,141.8c0-0.1,0.1-0.2,0.2-0.3c0.1,0.1,0,0.2,0.1,0.4 c0-0.1,0-0.1,0.1-0.1l0,0v0.1c0-0.1,0.1-0.2,0.1-0.1c0,0.1-0.1,0.1-0.1,0.3h0.1c0-0.1,0-0.1,0.1-0.1c0,0.1,0,0.2-0.1,0.3 c0,0,0.1-0.1,0.1,0s0,0.2-0.1,0.2c0-0.2,0-0.1-0.1-0.2c0,0.1,0,0.1-0.1,0.2l-0.1-0.1c0,0.1,0.1,0.1,0,0.2h-0.1v0.3 c-0.1,0.1,0,0.3,0,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c-0.1,0,0.1,0.2-0.1,0.3c0.1,0,0,0.2,0.1,0.3 s-0.1,0.1,0,0.2l0,0v0.6c0-0.1,0-0.1,0.1-0.1l0,0v0.2l-0.1-0.1c0,0.1,0,0.1,0.1,0.2c0-0.1,0-0.1,0.1-0.1l0,0v-0.1h-0.1V145l0,0 c-0.1-0.1,0-0.2,0.1-0.3c-0.1,0.1,0.2,0.3,0,0.3c0,0.1,0,0.1,0.1,0.1l0,0l0,0c-0.1-0.2,0.1-0.1,0-0.2c-0.1-0.1,0-0.2-0.1-0.3 c0,0.1,0,0.1-0.1,0.1l0,0c0.1-0.2-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0.1-0.1l0,0c0-0.1,0-0.2,0.1-0.3c0,0.1,0,0.3,0.1,0.2 c0-0.1,0-0.1-0.1-0.1l0,0c0.1-0.1,0-0.4,0.1-0.4l0,0c0-0.2-0.1-0.2,0-0.4c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l0,0 c0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0,0.1-0.1,0v-0.2c0-0.2,0.1-0.3,0.2-0.4c0,0.1,0,0.2-0.1,0.2s0.1,0.1,0.1,0.2 c0,0.1,0.1-0.1,0.2-0.1c0.1,0-0.1,0.2,0,0.2v-0.2c0.1,0.2,0.1,0.3,0.1,0.5c0-0.1,0.1,0,0.1-0.2c0,0.1-0.1,0-0.1,0 c0.1-0.1,0.1-0.2,0.1-0.3c0,0-0.1,0.1-0.1,0c-0.1-0.2,0-0.4,0.1-0.6h-0.1v-0.1c0.1,0.1,0.1,0,0.2-0.1h-0.1v-0.2l0,0 c0-0.1,0.1-0.2,0.1-0.3h0.1c-0.1,0-0.1,0.2-0.2,0.2s0.1-0.2,0.1-0.3s0,0.1-0.1,0c0-0.1,0-0.1,0.1-0.1l0,0c0,0-0.1,0.1-0.1,0 c0-0.3,0.2-0.3,0.2-0.4c-0.1,0.1,0-0.1-0.1-0.1s0,0.1-0.1,0.1v-0.1l0,0c0.1-0.1,0-0.1,0.1-0.2l-0.1-0.2h0.1V140 c0,0,0.1,0.1,0.1-0.1h-0.1v-0.1h0.1v-0.1c0.1-0.1,0.2-0.2,0.2-0.4h-0.1l0.1-0.2l0,0l0,0c0-0.1,0-0.1,0.1-0.1l0,0l0,0 c0-0.1-0.1,0,0-0.2c0,0.1,0,0.1-0.1,0.1l0,0c-0.1,0.2-0.2,0.4-0.2,0.6v-0.1l0,0c-0.1,0,0-0.1-0.1,0c-0.1,0.1,0,0.1-0.1,0.1v0.1 c0-0.1,0-0.1,0.1-0.2c0.1,0.1,0.1,0.1,0,0.2c0,0,0,0,0,0c-0.2,0.2-0.1-0.2-0.2-0.2l0,0c0.1-0.1,0,0,0-0.1s0.1,0.1,0.2-0.1 c0.1-0.2-0.3-0.2,0-0.3l0.1-0.2c0-0.1,0.1-0.1,0.1-0.2s0-0.2,0-0.2h-0.1c0.1-0.1,0-0.1,0.1-0.2h-0.1c0,0.1,0,0.1-0.1,0.1l0,0v-0.5 c0,0.1-0.2,0.1-0.2,0.3l0,0c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0,0.2,0.1,0.1v-0.1h0.1c0,0.1-0.1,0.2-0.2,0.2v-0.1 c0,0.2-0.1,0.4-0.2,0.6l0.1-0.1v0.1H208c0.1,0.4-0.2,0.4-0.2,0.7l0,0c0,0.2-0.1,0.1-0.1,0.3s0.1,0,0.1,0c0.1,0.2-0.1,0.1,0,0.3 c-0.1,0.1-0.1,0-0.1,0.1l0,0c0,0.2,0,0-0.1,0.1c0,0.3,0.1,0.4,0,0.7l-0.1-0.1c0.1,0.1-0.1,0.1,0,0.2h-0.1V141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,141.2L208.5,141.2C208.7,141.1,208.5,141.1,208.5,141.2L208.5,141.2v0.2 C208.6,141.4,208.6,141.3,208.5,141.2C208.6,141.2,208.6,141.2,208.5,141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,139.1L209,139.1c0.1-0.1,0.1-0.2,0.1-0.1L209,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,138.9L208.9,138.9C209,138.8,209,138.9,208.9,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,144.5L211.8,144.5C212,144.5,211.9,144.6,211.8,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,137.8c0.1,0,0.1,0,0.2-0.1v-0.1C208.7,137.8,208.7,137.8,208.5,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,138.8c-0.1,0,0.1-0.4-0.1-0.2c0,0.1,0,0.1,0.1,0V138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,143.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,143.7c0,0,0.1,0.1,0.1,0C211,143.8,211,143.6,210.9,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,145.1v-0.2h-0.1L211.8,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,144.2v0.1C211.1,144.3,211,144.2,211.1,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,144.8c-0.1,0.1,0.1,0.3,0,0.2c0,0.1,0,0.2,0.1,0.2s0.1,0,0.1-0.1l0,0c0-0.2,0.2,0,0.2-0.2 c-0.1,0,0-0.2,0-0.2s-0.2,0-0.2,0.2l0,0L211.3,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,137.1c0.1-0.2,0.2-0.5,0.2-0.7l0,0c0,0.1-0.1,0.1-0.1,0.2l-0.1,0.2V137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.1,137.2l-0.1,0.1l0,0c0,0.1,0.1,0,0.1,0.1v0.1C208.1,137.3,208,137.3,208.1,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,140.1L208.7,140.1v0.1l0.1-0.1C208.8,140.1,208.8,140.2,208.7,140.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211,144.3 210.9,144.4 211.1,144.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.9,145.5L211.9,145.5c0.1-0.1,0-0.1,0.1-0.1h-0.1C212,145.4,211.9,145.5,211.9,145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,145.2c0,0.1-0.1,0.2,0,0.2C211.9,145.4,211.9,145.2,211.8,145.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.3,142.1 209.4,142 209.4,142  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,140.7l0.1-0.1h-0.1C208.5,140.7,208.7,140.7,208.5,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,144c0,0,0.1,0.2,0.1,0.1S210.4,144.2,210.3,144L210.3,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,145.2c0,0,0,0.2,0.1,0.2l0,0C211.5,145.2,211.5,145.2,211.4,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208,138.8L208,138.8c-0.1-0.1-0.1-0.1-0.2-0.1c0.1,0.1,0.1,0.1,0,0.2c0,0,0,0,0,0c0-0.1-0.1,0-0.1,0 c0,0.2,0.1,0,0.2,0v-0.1H208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,137.9L207.6,137.9c0-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1,0.1-0.1,0.1V137.9h-0.1v0.1L207.6,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.6,144.4c-0.1,0.1,0.1,0.1,0.1,0.1C210.6,144.5,210.6,144.5,210.6,144.4 C210.6,144.4,210.6,144.4,210.6,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,145.5v0.1c0-0.1,0-0.2,0.1-0.2L211.3,145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,141.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.2,142.7 209.2,142.8 209.3,142.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "207.6,138.8 207.7,138.7 207.6,138.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,145.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.5,144.8 210.5,144.8 210.6,144.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,141.6c0,0.1,0.1-0.2,0.1-0.2C208.5,141.4,208.5,141.5,208.4,141.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.5,145.8 211.5,145.9 211.6,145.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.2,146.7c0-0.1,0-0.2-0.1-0.3C212.1,146.5,212.1,146.6,212.2,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,145.6v-0.1C211,145.7,210.9,145.5,211,145.6C210.9,145.8,211,145.8,211,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.8,145.2v0.1c-0.1-0.1-0.1-0.1-0.2-0.1v0.2h0.1l-0.1,0.1c0,0.1,0.2,0.1,0.1,0.2l0,0c0.1,0.1,0,0.1,0,0.2 c0,0.1,0.1-0.2,0.1-0.2c-0.1-0.2-0.1,0-0.1-0.2l0,0c0-0.1,0-0.1-0.1-0.1c-0.1,0,0,0.1-0.1,0C210.8,145.4,210.7,145.3,210.8,145.2 L210.8,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,142.8L208.7,142.8c0.1-0.1,0.1-0.2,0.1-0.1l-0.1-0.2c-0.1,0.1,0,0.1-0.1,0.2 C208.5,142.7,208.6,142.8,208.7,142.8L208.7,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,142.8l0.1-0.1v-0.2C208.4,142.7,208.4,142.7,208.4,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.2,146.7l-0.1,0.1h0.1V146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,145.8c0,0.1,0.1,0.1,0,0.1l0.1-0.1H211.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.3,143.8 209.2,143.9 209.2,143.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209,143.4 208.9,143.5 208.9,143.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.2,144v-0.1h-0.1L209.2,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.5,145.8c0,0-0.1-0.1,0-0.1l0,0c0-0.2-0.1,0.1-0.1-0.1C210.3,145.5,210.5,145.6,210.5,145.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.1,145.3 210.1,145.2 210,145.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.6,145.9L210.6,145.9c0.1,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2,0,0.2-0.1l0,0V146c0-0.1-0.1-0.2-0.2-0.3 L210.6,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.4,145.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.1,140.2L207.1,140.2C207,140.2,207.1,140.3,207.1,140.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.1,145.6 210.2,145.6 210.3,145.6 210.2,145.6 210.2,145.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "208.4,143.6 208.5,143.6 208.5,143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "208.7,143.5 208.5,143.6 208.5,143.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,142v0.2l0.1-0.1C207.6,142.2,207.7,141.9,207.7,142z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "208.1,143 208.2,143.2 208.2,143  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,143.9c-0.1,0,0,0.2-0.1,0.1c0,0.1,0,0.2-0.1,0.2h0.1c0,0-0.1,0,0-0.1S208.8,144,208.7,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.9,140c0,0.1-0.1-0.1-0.1,0l0.1,0.1V140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,147c-0.1,0,0,0.1,0,0.1S211.7,147.1,211.6,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.6,139v-0.1c-0.1,0-0.1,0.2-0.1,0.2v0.1C206.5,139.3,206.5,138.9,206.6,139z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "208.8,144.3 208.9,144.2 208.8,144.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.8,145.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,147.2L211.6,147.2C211.7,147.3,211.6,147.1,211.6,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,146.7L210.7,146.7l0.1,0.2c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0v-0.1l0,0v-0.1 C210.8,146.8,210.8,146.7,210.7,146.7L210.7,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,147.6l0.1,0.2C211.8,147.7,211.8,147.6,211.7,147.6C211.8,147.5,211.7,147.5,211.7,147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,147.4L211.7,147.4C211.8,147.4,211.8,147.5,211.7,147.4c0-0.1,0-0.1,0.1-0.1l0,0h-0.1V147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.1,142.1c0.1,0.1,0-0.2,0.1-0.3l0,0c0-0.1,0-0.1,0.1-0.1l0,0c-0.1,0.1-0.2,0.1-0.3,0.2h0.1L207.1,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,145.8c0,0.1-0.1,0.1-0.1,0.2s0.1,0,0.2,0.1c0-0.1,0-0.1,0.1-0.1l0,0c0-0.1-0.1-0.2,0-0.2 c-0.1,0-0.1-0.2-0.1-0.2s0-0.2,0-0.3H209c0-0.1,0.1-0.1,0.1-0.2c0,0.1-0.1,0-0.1-0.1h0.1c0-0.1-0.1-0.2-0.1-0.1v-0.1l-0.1,0.2l0,0 c0.1,0.3-0.2,0.2-0.1,0.5l-0.1,0.1C208.9,145.6,208.9,145.8,209,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.3,144.2L208.3,144.2C208.4,144.1,208.3,144.1,208.3,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,144.3v-0.1l-0.1,0.1C208.4,144.3,208.4,144.4,208.4,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.3,144.4c0.1,0,0,0.3,0.1,0.3v0.1c0,0.1,0.1,0.1,0.1,0.3v-0.2l0,0v-0.1c0-0.1,0.1,0.1,0-0.1 c-0.1,0,0,0.1-0.1,0.1c0-0.2,0.1-0.1,0.1-0.3c0,0.1-0.1,0-0.1,0s0-0.1,0.1-0.2C208.4,144.3,208.4,144.5,208.3,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,147.2L211.1,147.2C211.2,147.3,211.1,147.3,211.1,147.2L211.1,147.2c-0.1,0.1,0,0.2,0,0.3 s0.1-0.1,0.2-0.1l0.1,0.1v-0.1c-0.1-0.1-0.1,0-0.1,0S211.2,147.3,211.1,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.1,144.3L208.1,144.3c0.1,0,0-0.2,0-0.2v0.1l0,0C208.2,144.2,208.1,144.2,208.1,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,147.6c0-0.1-0.1-0.2-0.1-0.3c0,0.1-0.2-0.2-0.1,0l0,0c0,0.1,0.1,0.3,0.1,0.4h0.1V147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.9,148.1L211.9,148.1v-0.3h-0.1C211.8,147.9,211.9,148,211.9,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,147.9c0,0.1,0.1,0.2,0.1,0.3l0,0C211.8,148.1,211.8,148,211.7,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,144.8L208.2,144.8v-0.2l0,0v-0.1c0,0,0-0.2-0.1-0.1l0,0v0.3l0,0C208.2,144.8,208.2,144.8,208.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.8,142v0.4c0-0.2,0.1,0,0.1-0.2C206.9,142.1,206.9,142,206.8,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,144.8L208.2,144.8c0.1,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2H208.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.8,142.4 206.8,142.6 206.9,142.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.8,142.7c0,0.1-0.1,0.3-0.1,0.4V143l0.1,0.2V143c0.1,0,0.1-0.2,0.2-0.3 C207.1,142.6,206.9,142.8,206.8,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.2,143.3c-0.1-0.1,0,0.1-0.1,0.1S207.2,143.4,207.2,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.2,147L210.2,147v0.3c0.1,0,0,0.2,0.1,0.1c-0.1,0,0-0.2-0.1-0.3C210.2,147.2,210.3,147.1,210.2,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.8,146.8l-0.1-0.1v-0.2c0,0.2-0.1,0-0.1,0.1c0,0.1,0,0.2,0.1,0.3c-0.1,0,0-0.3-0.1-0.3 c0,0.1,0.1,0.2,0.1,0.3c-0.1,0.1,0,0.3-0.1,0.3c0.1,0.1,0-0.1,0.1-0.1v0.1c0-0.1,0-0.1,0.1-0.1c-0.1,0.1,0,0.1,0,0.2l0.1-0.1 C206.9,147.1,206.8,147,206.8,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.2,143.6c-0.1-0.1,0-0.1,0-0.2c0,0.1-0.1,0.1-0.1,0.2v0.4c-0.1,0,0-0.2-0.1-0.2v0.2 c-0.1-0.1,0,0.1-0.1,0.2l0,0c0,0,0.1,0.3,0,0.3c0,0.1,0,0.1-0.1,0.1l0,0v0.1c0-0.1,0.1,0,0.1-0.1v0.2h-0.1c0,0.1,0.1,0,0.1,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1,0,0.1,0c0,0.2-0.1,0-0.1,0.1h0.1c0,0.1,0,0.1-0.1,0.1c-0.1-0.2,0-0.3,0-0.4 c0,0.1,0,0-0.1,0.1l0,0c-0.1,0.3,0.2,0.6,0.1,0.9l0,0c0,0.1,0.1,0.2,0,0.3h-0.1c0,0.1,0.1,0.2,0,0.3s0.1,0.3,0,0.5h-0.1 c0.1,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1,0,0.1,0.1v0.2c0,0,0-0.2,0.1-0.1c0.1,0.1,0.1,0.3,0,0.4l-0.1-0.1v0.2c-0.1-0.1,0-0.3-0.2-0.3 v0.3c0.1,0.1,0.1,0.1,0.1,0.2l0,0c0,0.2,0.1,0.4,0,0.5c0-0.1-0.1-0.1,0-0.2l0,0c0.1-0.1-0.1-0.3,0-0.3c-0.1,0-0.1-0.1-0.2,0 c0.1-0.1-0.1-0.2,0-0.3l-0.1,0.1c0.1,0,0,0.1,0.1,0.3c0-0.1,0,0,0.1,0s0.1,0.1,0.1,0.3l-0.1-0.1c0.1,0.1-0.1,0,0,0.2l0,0 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.4,0,0.4l0,0v0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0.1,0,0,0.1,0,0.2l0,0c0,0.2,0.2,0.2,0.2,0.3 v0.2l0.1-0.1v0.2c0-0.1,0.1,0.1,0.1,0v-0.1h0.1c0,0.2,0,0.1,0.1,0.2c0.1-0.1,0-0.4,0-0.6h0.1c-0.1,0,0-0.2-0.1-0.1 c-0.2-0.2-0.1-0.5-0.3-0.7c0.1-0.1,0.2-0.1,0.1-0.2l0.1,0.1c0-0.2,0-0.2,0.1-0.2s0.1,0.3,0.2,0.3l0,0l0,0c0.1,0,0,0.2,0,0.2h0.1 c0,0.1,0.1,0.4,0.1,0.5v-0.1l0.1,0.1c0.1-0.1-0.1-0.4-0.1-0.5h-0.1c-0.1-0.2-0.1-0.4-0.2-0.6l0,0c-0.1-0.1-0.1-0.1-0.1-0.2h0.1 v-0.2l0,0c0-0.1,0-0.3-0.1-0.2v-0.2c0.1,0.1,0.1,0,0.1-0.1c0-0.1,0,0.1-0.1,0v-0.1c-0.1,0,0-0.1-0.1,0v-0.1h0.1 c0-0.1,0.1-0.3,0-0.4l0.1-0.1h-0.1c0-0.2,0.1-0.2,0.1-0.5l0.1,0.1c0,0,0-0.1,0.1,0l0,0h-0.1v-0.1h0.1l0.1-0.1 c-0.1-0.1-0.2-0.2-0.1-0.3c0.1-0.1,0.1-0.1,0.1,0v-0.2l-0.1,0.1v-0.4c-0.2,0,0-0.3-0.1-0.3v-0.7l-0.1-0.1v0.1h-0.1v-0.2h-0.1v-0.1 c0,0-0.1,0.1-0.1,0v-0.1l0,0C207.3,143.7,207.2,143.6,207.2,143.6L207.2,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,145.1V145C208.1,145,208.2,145.1,208.2,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,147.8l-0.1-0.1v-0.1h-0.1v0.1c-0.1-0.1-0.1,0.1,0,0.2v-0.2C210.7,147.8,210.8,147.8,210.9,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206,140.9l-0.1-0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.1,0.1,0.2v-0.1l0,0 C205.8,141.1,205.9,141,206,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,147.1c0,0.1,0,0.1,0.1,0.1L209.7,147.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.2,148.2 211.2,148.2 211.1,148.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,146.8C208.2,146.7,208.3,146.7,208.2,146.8l0.1-0.2L208.2,146.8c0-0.1,0-0.4-0.1-0.3l0.1-0.1v-0.7h-0.1 v-0.2l0,0v-0.1c-0.1,0.1,0,0.1,0,0.2c0,0.1-0.1-0.1-0.2-0.1c0.1,0.1,0,0.3,0.1,0.5v-0.1c0.1,0,0.1,0.1,0,0.2h-0.1 c0-0.1,0.2,0,0.1,0.1l0,0c0,0.1,0.1,0.2,0,0.3l0,0v0.2c-0.1-0.1,0-0.1,0-0.2v0.2h0.1C208.2,146.7,208.2,146.7,208.2,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.6,147L209.6,147l0.1,0.1L209.6,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.8,141.6c0-0.1,0.1-0.1,0.1-0.2h-0.1V141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,146c0,0.2,0.1,0.1,0.2,0.1v-0.2C208.5,146.1,208.4,145.9,208.4,146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.9,147.3 209.8,147.3 209.8,147.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.7,142.2c0-0.2,0.2-0.2,0.1-0.4l0,0c0-0.1,0.1-0.1,0.1-0.2c-0.1,0.1-0.1-0.1-0.1,0v0.1l-0.1,0.1 c0,0.1,0,0,0.1,0C205.9,141.8,205.7,142.1,205.7,142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,148.4L211.3,148.4C211.2,148.4,211.2,148.5,211.3,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,152.3c0-0.1-0.1,0-0.1,0H211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,153.1L211.5,153.1C211.6,153.2,211.5,153.2,211.5,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,148.7c0-0.1,0.2,0.1,0.1-0.1C208.9,148.4,208.9,148.6,208.9,148.7c-0.1-0.1,0-0.2,0-0.3v-0.1 c0.1-0.1,0.1,0.1,0.1,0.1s-0.1-0.1-0.1-0.2l0,0c0-0.1-0.1-0.1,0-0.2c0.1,0.1,0.1,0.3,0.2,0.4l0,0c0.1,0,0.1,0,0.2,0.1l0,0 c0,0,0.1-0.1,0.1,0c0,0.1-0.1,0,0,0.2c0.1,0.2,0,0,0-0.1c0-0.1,0.1,0.2,0.2,0.1s0,0.2-0.1,0.1c-0.1,0.1,0.1,0.2,0.1,0.3V149 c0.1,0,0.1,0.2,0.1,0.2h0.1c0,0.1,0,0.2,0.1,0.3h0.1c0,0.1,0,0.1-0.1,0c0.1,0.2,0,0.1,0,0.3c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0v0.1 l-0.1-0.1c0,0.1,0.1,0.2,0.2,0.3c-0.1,0.1-0.1,0.3,0,0.3h-0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1-0.1,0.1,0,0.2l0,0v0.1l0,0l0.1,0.1 l0,0l0,0c0,0.1,0.2,0.2,0.2,0.3l0,0c0,0.1,0,0.2,0.1,0.2s-0.1-0.1-0.1-0.1l0,0c0.1,0.1,0.2,0.2,0.2,0.4c-0.1,0-0.1-0.1-0.2-0.1 s0.2,0.2,0,0.2c0.1,0.3,0.4,0.2,0.4,0.5v-0.1l0,0c0.1-0.1-0.3-0.3-0.1-0.2l0,0c0-0.1-0.1,0-0.1-0.1v-0.1l0,0l0.1-0.1 c0.1,0.1,0.2,0.2,0.2,0.3l-0.1,0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0l0,0c0.1,0.2,0.1,0,0.2,0.2c0.1,0,0-0.1,0.1,0 c0,0.1,0,0.2,0.1,0.3l0,0c0.1,0.1,0.1,0,0.2,0.1c0-0.1,0-0.1-0.1-0.1l0,0l0,0l-0.1-0.1h0.1c0-0.2-0.3-0.4-0.4-0.6h0.1 c0-0.1,0-0.1-0.1-0.1l0,0l0,0c-0.1-0.2-0.3-0.2-0.4-0.4v0.1c0-0.1-0.1-0.1-0.1-0.2h0.1c-0.2,0-0.1-0.1-0.3-0.1v0.1h-0.1 c0.1,0-0.1-0.1,0-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.3-0.2-0.5c-0.1-0.2,0-0.3-0.1-0.5l0,0c0-0.1,0-0.1,0.1-0.1l0,0 c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.1,0.1-0.1,0.2,0c0,0.1,0,0.1-0.1,0.1l0,0c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0,0.1 c0.2,0.1,0.1,0.2,0.2,0.3v0.1h0.1v0.1c0.1,0.1,0.2,0,0.2,0.1v-0.1c0,0.1,0.1,0.3,0.2,0.3l-0.1-0.2l0,0c0.1,0.2,0.2,0.2,0.2,0.4 h-0.1c0,0.1,0,0.1,0.1,0.1l0,0l-0.1-0.1v0.1c0.1,0,0.1-0.1,0.1-0.2c0.1,0.1,0.1,0.1,0.2,0.1c-0.1-0.1,0.1,0,0-0.1 c-0.1-0.1-0.1-0.2-0.2-0.3l0,0l-0.1-0.1v-0.1l0.1,0.1c0-0.1-0.1-0.2-0.1-0.3c-0.1,0-0.1,0-0.1-0.1c0.1,0.1,0.1,0,0.1,0l-0.2-0.2 h0.1c0,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3l0,0l-0.2-0.2v0.1c-0.1,0-0.2-0.2-0.3-0.2H210c0.1-0.1,0.1,0.1,0.1,0.1v-0.1H210 c-0.1-0.1-0.2-0.2-0.1-0.3l0,0l-0.1,0.1c0-0.1,0-0.2-0.1-0.2v-0.1c-0.1,0,0-0.2-0.1-0.2l0,0c-0.1-0.2,0-0.3-0.1-0.4 c-0.2-0.3-0.3-0.6-0.3-0.9c0.1,0,0-0.1,0.1-0.1l0,0c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0v-0.2c-0.1,0-0.1,0.1-0.2,0 c-0.1-0.1,0-0.3,0-0.5c-0.1,0.1,0-0.2-0.1-0.1v-0.1c0,0.1-0.1,0-0.1-0.1c0,0.1-0.1,0.2,0,0.4h0.1v0.3c0.1,0,0.1,0,0.1,0.1 c0,0,0,0,0,0v0.1c0-0.1-0.1,0-0.1-0.1v0.1l0,0c0,0.2-0.1,0.1-0.1,0.2l0,0v0.2l0,0c0.1,0,0,0.2,0.1,0.4c0.1-0.1,0.1,0.1,0.1,0.2 s-0.2-0.3-0.3-0.2c0.1,0.2,0,0.3,0,0.4C208.7,148.3,208.7,148.7,208.9,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.2,151.5v0.1C210.3,151.6,210.2,151.5,210.2,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.9,147.4v0.2C210,147.5,210,147.4,209.9,147.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.3,148.5 211.4,148.6 211.3,148.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.2,142.8l-0.1,0.2c0.1-0.1,0.1,0,0.1,0.1C206.2,143.2,206.2,142.9,206.2,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,147.4L209.7,147.4C209.8,147.4,209.8,147.3,209.7,147.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.5,148 210.5,148 210.4,147.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.3,143.3c0-0.1,0.1,0,0.1-0.1l-0.1-0.1V143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,148.5v-0.4l0,0c0-0.1,0,0-0.1-0.1C210.6,148.3,210.6,148.4,210.7,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,146.4L208.5,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,148.8c-0.1-0.1-0.1-0.1-0.1-0.2c0,0.1,0.1,0.1,0,0.2c0-0.1,0-0.1-0.1-0.1l0,0c0.1,0.1-0.1,0.2,0.1,0.3 C211.4,148.9,211.6,148.9,211.5,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.8,142.5L205.8,142.5l0.1-0.2C205.8,142.2,205.7,142.3,205.8,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.7,144.1c0,0.2,0.1,0.2,0.1,0.4C206.8,144.5,206.9,144.2,206.7,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.4,149.9c0.1,0-0.1-0.1,0-0.1h-0.1v-0.2C213.1,149.7,213.3,149.9,213.4,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.6,144.5v-0.2C206.5,144.4,206.6,144.4,206.6,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.1,148.5l0.1-0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0C210,148.3,210.1,148.4,210.1,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,149.3C211.4,149.3,211.3,149.2,211.3,149.3l-0.1-0.2C211.3,149.1,211.3,149.3,211.3,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,146.3l0.1,0.2C207.8,146.4,207.8,146.3,207.7,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.5,148.2L209.5,148.2C209.4,148.1,209.5,148.1,209.5,148.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "207.6,146.4 207.7,146.3 207.6,146.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.6,149.6 211.7,149.6 211.6,149.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,148.9h0.1C210.3,148.8,210.3,148.9,210.3,148.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,149.9c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0,0.1,0l-0.1-0.1h0.1c0,0-0.1-0.1,0-0.1 C212.4,150,212.4,149.9,212.3,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.1,144.6v0.1C206.2,144.5,206.2,144.6,206.1,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.5,149.3l0.3,0.6v-0.1c0.1,0,0.2,0.2,0.1,0.2l0.1-0.1l0.1,0.1l0,0v0.1H211c0.1,0,0.1,0,0.1,0.1 c0,0,0,0,0,0v-0.1c0-0.2,0-0.3-0.2-0.4c0.1,0,0-0.1,0-0.1l0,0v-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0,0.1,0.2,0,0.3v-0.2 c-0.1,0,0,0.1,0,0.2l0,0v0.1c-0.1-0.2-0.3-0.3-0.4-0.5C210.5,149.2,210.5,149.2,210.5,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,150.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.8,146.5c0.1,0,0-0.1,0-0.3C206.8,146.3,206.7,146.4,206.8,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.8,146c0,0.1,0,0.1,0.1,0.2C206.9,146.2,206.8,146.1,206.8,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,149.9v0.2c0.1,0.1,0.1,0,0.1,0S211.3,149.9,211.2,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.3,143.8c0-0.1,0-0.1-0.1-0.1C205.1,143.7,205.2,143.8,205.3,143.8C205.2,143.8,205.2,143.9,205.3,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.2,148.5l-0.1,0.1C209.1,148.6,209.2,148.5,209.2,148.5C209.2,148.5,209.2,148.5,209.2,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.3,148.8L209.3,148.8C209.2,148.7,209.3,148.7,209.3,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.3,148.8v0.1C209.4,148.9,209.3,148.8,209.3,148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,150.6l0.1,0.1v-0.2h-0.1V150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.5,146.2c0.1-0.1,0.1-0.1,0-0.2c0,0,0,0,0,0V146.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.6,146.3 206.5,146.4 206.6,146.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.5,144.8v0.2C205.5,144.9,205.6,144.8,205.5,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.1,149.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.8,145.8c0.1,0.2,0-0.2,0.1-0.3v-0.1C205.8,145.5,205.8,145.6,205.8,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.4,144.8c0,0,0,0.2,0.1,0.1C205.6,144.8,205.4,144.9,205.4,144.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.2,149.7 210.2,149.7 210.1,149.7 210.2,149.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,150.6c0-0.1-0.1-0.2-0.1-0.1L211.6,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.3,149.5L209.3,149.5c0.1-0.2-0.1-0.1-0.1-0.3C209.2,149.3,209.3,149.4,209.3,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,150.1L209.7,150.1c0,0.1,0,0.1,0.1,0.1S209.7,150.2,209.7,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.4,151.5l-0.1-0.1L212.4,151.5C212.3,151.5,212.3,151.4,212.4,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,151.6c0-0.1-0.1,0-0.1-0.2h-0.1C212.7,151.5,212.6,151.7,212.7,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.5,152L214.5,152c-0.1-0.1-0.1-0.1-0.1-0.2l0,0C214.4,151.8,214.4,151.9,214.5,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.7,152.1L214.7,152.1L214.7,152.1c0-0.1,0-0.1-0.1-0.2L214.7,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,149.7L208.7,149.7c0-0.1,0-0.2-0.1-0.2c0,0.2,0.1,0.4,0.2,0.5C208.9,150,208.7,149.9,208.7,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.9,147.3c-0.1-0.1,0-0.2,0-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1,0.1,0.1,0.1,0.3l-0.1,0.1l0.1,0.2 C205.8,147.4,205.8,147.3,205.9,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.5,150.1c-0.1-0.1-0.1-0.3-0.1-0.4l0,0v-0.2c-0.1,0-0.3-0.1-0.2,0.1h0.1c0,0.1,0.1,0.4,0.1,0.5 C208.4,150,208.4,150.1,208.5,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.8,152.1v-0.2h-0.1v-0.1c0,0.1,0,0.1-0.1,0.1l0,0v0.1h-0.1C212.6,152,212.7,152,212.8,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.9,152.2c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0L214.9,152.2c0-0.1,0-0.1,0.1-0.1h-0.2 C214.8,152.2,215,152.2,214.9,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.5,152.3c0-0.1,0.1-0.1,0-0.2h-0.1v0.2H214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.6,153.2L210.6,153.2l0.1,0.1c-0.2-0.1,0-0.2-0.1-0.3l0.1,0.2v-0.1c0.1,0.2,0.2,0.3,0.3,0.4 c0-0.1,0.1,0,0.1,0l0.1,0.1c0,0,0.2,0.1,0.2,0c0-0.1-0.2-0.2-0.2-0.1c-0.1-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1,0 c0-0.2-0.3-0.3-0.3-0.4h-0.1v-0.1c-0.1,0-0.2-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1,0c-0.1-0.1,0.1-0.1-0.1-0.1v0.1c-0.1,0-0.2,0-0.2-0.1 v-0.1l0.1,0.1l0.1-0.1c0.2,0.1,0,0.2,0.2,0.2h0.1v-0.2c-0.1-0.1-0.2-0.3-0.3-0.3s0-0.1,0.1-0.1c-0.1-0.1,0,0.1-0.1-0.1 s-0.1-0.2-0.2-0.3l0,0c-0.1-0.1-0.2-0.3-0.2-0.5c-0.1,0.1,0,0.3-0.1,0.2c0.1-0.1-0.2-0.3-0.2-0.4s-0.1-0.1-0.1,0v-0.2 c-0.2-0.1,0-0.2-0.2-0.3l0.2,0.4c-0.1,0-0.1-0.1-0.2-0.1v-0.1c0,0.1-0.2-0.2-0.2-0.1c-0.1-0.1-0.1-0.3-0.2-0.4v0.1h-0.1 c0.1,0,0,0.1,0.1,0.2h-0.1c0,0.1,0,0.1,0.1,0.2v0.1c0.1,0,0.2,0,0.2,0.1v0.1l-0.1-0.1l-0.1,0.2c0.1,0,0.1-0.1,0.3,0 c0-0.1-0.1-0.1,0-0.1s0.1,0,0.2,0.1l-0.1,0.2l0,0c0,0.1,0.1,0.3,0,0.3h0.1c0.1,0.1,0.1,0.1,0.1,0.2l0,0v0.1c0.2,0,0.2,0.3,0.2,0.4 c0-0.1,0-0.1,0.1,0s0,0.1,0,0.2l0.1-0.1c0,0.1,0.1,0.1,0.2,0.1v0.1l0,0c0.1,0.2,0.2,0.1,0.2,0.3h-0.1c0.1,0.1,0.1,0.2,0.2,0.3 s-0.1,0,0,0.1C210.4,153.1,210.5,153.2,210.6,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.3,152c0.1,0.1,0,0.1,0.1,0.2C213.4,152.1,213.4,152,213.3,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,151.6L211.7,151.6l0.1,0.2C211.8,151.7,211.8,151.7,211.7,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.8,150.2c0-0.1-0.1,0-0.1-0.1C208.7,150.2,208.7,150.2,208.8,150.2L208.8,150.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "214.5,152.3 214.4,152.3 214.5,152.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,151.1c0,0.1,0,0.2,0.1,0.3h0.1C210.5,151.3,210.4,151.3,210.3,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,152.3c0,0.1-0.1,0-0.1,0.1c0.1-0.1,0.1,0.1,0.2,0l0.2,0.2c0.1-0.2-0.1,0,0-0.2h-0.1 C215.1,152.3,215,152.3,215,152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.9,151.9c-0.1-0.1-0.1,0.1-0.1,0.1l0,0l0.2,0.2C211.9,152.1,212.3,152.1,211.9,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.4,152.3L216.4,152.3C216.3,152.2,216.4,152.2,216.4,152.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0,0.1-0.1,0l0,0 C216.2,152.2,216.3,152.4,216.4,152.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.8,151.8 211.7,151.8 211.8,152  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,151.9l-0.1-0.1C211.4,151.9,211.3,151.9,211.4,151.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.3,148.4 206.3,148.5 206.4,148.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213,152.7v0.1C213.1,152.8,213.1,152.7,213,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,152.2c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.2,0.1,0.1,0.1h0.1c0,0.1,0,0.1,0.1,0.1l0,0c0-0.1,0-0.3-0.1-0.4 C212.8,152.2,212.8,152.4,212.7,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.2,148.4v-0.1C206.1,148.4,206.2,148.4,206.2,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.5,152.5l0.1,0.1C215.6,152.4,215.5,152.5,215.5,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.7,147.9c-0.1,0.1,0-0.1-0.1-0.2v0.3L205.7,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.8,152.6L214.8,152.6c0.2,0.1,0.3,0.2,0.5,0.3v-0.1l0.2,0.2c0-0.2-0.4-0.3-0.4-0.5 C214.9,152.7,214.9,152.6,214.8,152.6l0-0.1h-0.1L214.8,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,152.5C212.6,152.4,212.6,152.5,212.7,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.6,152.4L216.6,152.4l0.1,0.1l0,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2H216.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206,149.2L206,149.2L206,149.2c0-0.1,0-0.2-0.1-0.3l0,0c-0.1-0.2,0-0.2,0-0.4c0,0.1,0,0.1-0.1,0.1 c0.1-0.1-0.1-0.3,0-0.4c-0.1,0-0.1,0-0.1,0.1c0,0.1,0.2,0.5,0.1,0.6h0.1c0,0.1,0.1,0.2,0.1,0.4h0.1L206,149.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,152.4l-0.1-0.1C211.7,152.3,211.7,152.3,211.7,152.4C211.7,152.4,211.7,152.4,211.7,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,150.5L207.6,150.5c0.1,0.2,0.1,0.1,0.2,0.3c-0.1-0.2,0.1,0,0.1,0s-0.3-0.2-0.2-0.3 c0.1-0.1,0,0.1,0.1,0.1s-0.2-0.2-0.1-0.4c-0.1,0,0,0.1,0,0.2s-0.1-0.2-0.1-0.2l-0.1,0.1C207.6,150.2,207.5,150.4,207.6,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.4,149.4L206.4,149.4c0.1,0.2,0.2,0.4,0.3,0.5v-0.1c0-0.1,0,0-0.1,0c0-0.1,0-0.2-0.1-0.3v0.1 c0-0.1-0.1-0.2-0.2-0.3c0,0.1,0,0.2-0.1,0.2c0.1,0.2,0.1,0.1,0.1,0.3C206.5,149.7,206.5,149.4,206.4,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.5,150.5c-0.1-0.2-0.1-0.3-0.2-0.3v0.2l0,0L207.5,150.5c-0.1,0-0.1,0-0.2-0.1l0.1,0.2l-0.1-0.1v0.1 l0.1,0.1C207.3,150.5,207.5,150.5,207.5,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.7,150.3c-0.1,0,0.1,0.2,0.1,0.2S207.8,150.4,207.7,150.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.1,150.9c0,0.1,0,0.2,0.1,0.2l0,0c0.2,0.2,0,0.2,0.1,0.4c0.1-0.1-0.1-0.2,0-0.2c0.1,0.2,0.1,0,0.2,0.1l0,0 c0.1,0.1,0,0,0.1-0.1c0,0.1,0,0.1,0.1,0.2l0,0v0.1c0-0.1,0-0.1-0.1-0.2c0.1,0,0-0.2,0.1-0.3l0,0c-0.1-0.1-0.2-0.3-0.3-0.4v0.1 l-0.1-0.2c0,0,0,0.1-0.1,0c0-0.1,0-0.1-0.1-0.2v0.2l0,0c0-0.1,0.1,0,0.2,0s-0.1,0.1,0,0.1l0,0v0.3L207.1,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,151.6c0-0.1,0-0.1-0.1-0.1C207.5,151.6,207.6,151.6,207.6,151.6L207.6,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.1,150c0,0.1,0.1,0.2,0.1,0.3s0-0.3-0.1-0.4C207.1,150,207,149.8,207.1,150c-0.1,0-0.2-0.1-0.3-0.2v0.2 l0.1,0.1c0,0.1,0.1,0.2,0.1,0.3l0.1-0.1C207,150.1,207,150.1,207.1,150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.9,150.6L206.9,150.6L206.9,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.7,149.7l0.1,0.1L206.7,149.7C206.8,149.6,206.7,149.6,206.7,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.1,152.7L217.1,152.7c-0.1,0,0,0.1,0.1,0.2l0.1,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0.1,0.2,0.1,0.3,0.2l0,0v0.1 h0.3l0.9,0.3c0.1,0,0-0.1,0-0.1l-0.1-0.1h-0.1c-0.1,0-0.1,0-0.1-0.1c-0.2,0-0.2-0.1-0.3-0.1V153l0.1,0.1c0-0.1-0.3-0.1-0.4-0.2v0.1 c-0.2,0,0-0.1-0.2-0.1h-0.1c0-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.1,0.1-0.2,0c-0.1-0.1,0.1,0,0.1-0.1s-0.3-0.1-0.2-0.2 C217.3,152.7,217.3,152.7,217.1,152.7L217.1,152.7C217,152.7,217.2,152.6,217.1,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.5,153.3L214.5,153.3v-0.1c0.1,0.1,0.2,0.1,0.2,0.2l0,0c0.1,0,0.2,0.1,0.1,0.2c0-0.1,0-0.1-0.1,0 c0.1,0.1,0.1,0,0.2,0.1c0-0.1,0.1-0.1,0-0.2c0,0.1-0.1,0-0.1,0.1c-0.1-0.1,0,0,0-0.1s-0.1-0.1-0.1,0l0.1,0.1 c-0.2,0.1-0.2-0.3-0.4-0.2C214.5,153.2,214.5,153.3,214.5,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.5,153L215.5,153C215.4,153,215.7,153.1,215.5,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.7,149.2c0-0.2-0.1-0.1-0.1-0.2C205.6,149.1,205.6,149.1,205.7,149.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,153l0.1,0.1C212,153.1,211.9,153,211.8,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,152.9l-0.1-0.1l0,0C211.1,152.9,211.1,152.9,211.2,152.9L211.2,152.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.1,149.7 206.1,149.5 206,149.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.3,151.7c0,0,0.1,0.1,0.1,0l0.2,0.3h0.1c0-0.2-0.1-0.2-0.1-0.3l0,0v-0.1c-0.1-0.1-0.2-0.2-0.2-0.3 c0,0.1,0.1,0.3,0.2,0.3L208.3,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.9,153.6L215.9,153.6c0.1,0.1,0.1,0.3,0.3,0.3v-0.1h-0.1c0.1-0.1-0.3-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1v0.1c-0.1,0,0-0.1-0.1-0.2c0,0.1-0.1,0,0,0.1C215.8,153.3,215.9,153.5,215.9,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.3,153.4v-0.1C215.2,153.3,215.3,153.3,215.3,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,153c0.1,0,0-0.1,0-0.1S211.3,153,211.4,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,153.2v-0.1c0,0-0.1,0.1-0.1,0L211.8,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.1,153.1c-0.1-0.1,0-0.1,0-0.1S211,153,211.1,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,153.4c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.3-0.1v0.2l0.3,0.3c0-0.1,0.1,0,0.1,0l-0.2-0.2 c0.1,0,0.1-0.1,0-0.1C212.2,153.4,212.3,153.5,212.3,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.6,149.9L205.6,149.9c-0.1-0.1,0-0.1-0.1-0.2c-0.1-0.1,0,0.2-0.1,0c-0.1-0.2,0.1-0.1,0-0.3s-0.2-0.3-0.2,0 c0,0.1,0.2,0.3,0.2,0.4c0,0.1,0.2,0.2,0.2,0.3C205.6,150,205.5,149.9,205.6,149.9l0.1,0.4l0,0l0.1,0.1c0.1-0.1-0.1-0.2-0.1-0.4 C205.6,150,205.6,149.9,205.6,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.6,153.4L216.6,153.4l-0.2-0.1C216.5,153.3,216.5,153.3,216.6,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.9,150.9L206.9,150.9v-0.1C206.8,150.9,206.8,150.9,206.9,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.1,151c0-0.2-0.1-0.4-0.2-0.5l0.1,0.2h-0.1v0.3l0.1,0.1c0,0.1-0.1,0.1,0,0.2 C207,151.2,207.1,151.2,207.1,151H207C206.9,150.9,207,151,207.1,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.8,153.6L212.8,153.6c0.1-0.1,0-0.1-0.1-0.2L212.8,153.6c0-0.1,0-0.1-0.1-0.1 C212.7,153.5,212.8,153.6,212.8,153.6L212.8,153.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "207.7,151.5 207.8,151.6 207.8,151.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.1,152.8v0.1l0,0v0.1C210.1,152.9,210.2,152.9,210.1,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.9,153.7c0.1,0.1,0.1,0.1,0.2,0.1C213,153.7,213,153.7,212.9,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.7,153.4c0.1,0.1,0.2,0.1,0.3,0.2h-0.1c-0.1,0,0.1,0,0,0.1h0.1c0,0.1-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2-0.1 c0.1,0,0.2,0.1,0.3,0.2c-0.1-0.1,0.1,0,0.1-0.1l-0.1-0.1c0-0.1,0.1,0,0.1-0.1v0.1c0-0.1,0-0.1-0.1-0.1l0,0c-0.1,0,0,0.1-0.1,0v-0.1 h0.1C216.9,153.5,216.8,153.4,216.7,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.3,152.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,152.3l-0.1-0.1C208.8,152.2,208.8,152.3,208.9,152.3L208.9,152.3h-0.1v0.1 C208.8,152.2,208.8,152.4,208.9,152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.8,152.4c0,0.1,0,0.1,0.1,0.2v-0.2C208.9,152.3,208.9,152.4,208.8,152.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "216.7,153.6 216.7,153.5 216.6,153.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.3,153.1l-0.1-0.1L210.3,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.3,153.8c0-0.1,0-0.1-0.1-0.1l0,0C215.2,153.8,215.2,153.8,215.3,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.9,153.1c-0.3,0-0.1-0.2-0.4-0.3l0,0c0-0.1-0.1-0.2-0.1-0.1c0,0.1,0.3,0.4,0.3,0.5l0,0l0.1,0.1v-0.1 c0.1,0,0.2,0.1,0.2,0.2l0,0C209.8,153.2,210.1,153.4,209.9,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,154l-0.1-0.2c-0.2,0-0.4-0.4-0.5-0.4v-0.1l0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c0,0.1,0,0.2,0.1,0.3l0,0v0.1 c-0.1,0,0-0.1-0.1-0.1c-0.1,0,0.1,0.1,0,0.2h0.1l0.1,0.1h-0.1c0.2,0.1,0,0.2,0.1,0.3C210.8,153.8,211,154.3,211.2,154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.6,153.7C216.7,153.7,216.5,153.6,216.6,153.7L216.6,153.7C216.5,153.6,216.6,153.6,216.6,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,153.5C211,153.5,211,153.4,210.9,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.7,154.2c0,0.1,0.2,0.1,0.2,0.2l0,0c0.1,0.1,0.1,0,0.2,0c0.1,0-0.1-0.3-0.2-0.3s-0.2-0.1-0.3-0.2 c-0.1-0.1,0.1,0.1,0.1,0c0.1,0.2-0.1,0.1-0.1,0.1L213.7,154.2L213.7,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,153.1C210,153.2,210.1,153.1,210,153.1C210.1,153.1,210,153,210,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.2,153.2C210.1,153.2,210.1,153.1,210.2,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.5,154.1L213.5,154.1V154C213.4,154,213.6,154.1,213.5,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209,152.6L209,152.6v0.1C209,152.7,209.1,152.7,209,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.9,152.1c-0.1-0.2-0.1-0.1-0.1-0.1C207.8,152,207.9,152.1,207.9,152.1L207.9,152.1 C207.8,152.1,207.9,152.2,207.9,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.7,150.2L205.7,150.2c-0.1,0.1-0.1,0.1,0,0.2c0,0,0,0,0,0C205.6,150.3,205.7,150.3,205.7,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.8,153.7c0.2,0.1,0.1,0,0.2,0.1C219,153.7,218.8,153.8,218.8,153.7L218.8,153.7c0.1,0,0.1,0,0.1-0.1 c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.1l0.1-0.1c-0.1,0-0.2,0-0.3-0.1h-0.1C218.4,153.6,218.8,153.5,218.8,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,153.8c0,0,0.1,0.1,0,0.1h-0.1l0.1,0.1l0,0c0-0.1,0.1,0.1,0.2,0.1S211.8,153.8,211.8,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,153.7c0,0.1,0.1,0.2,0.2,0.2C211.7,153.8,211.6,153.8,211.5,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,152.2l0.1,0.1l-0.2-0.3C207.6,152.1,207.7,152.2,207.6,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.5,151.2L206.5,151.2c0.1,0,0,0,0-0.1V151.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.4,153.8 211.5,153.9 211.5,153.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.1,153.4L210.1,153.4l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1S210.1,153.5,210.1,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.3,154.4c0.1,0-0.1-0.1-0.1-0.1L214.3,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.9,154.4l-0.1-0.1C213.7,154.4,213.7,154.4,213.9,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.5,153.9c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0s0-0.1,0.1,0C217.6,153.9,217.5,153.8,217.5,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.7,151.9L206.7,151.9l-0.1-0.1C206.7,151.7,206.8,151.9,206.7,151.9s-0.1-0.3-0.1-0.1l-0.1-0.2v0.1h-0.1 c0.1,0.3,0.2,0.5,0.4,0.7c0-0.1,0-0.1-0.1-0.1l0,0l0.2,0.1C206.8,152.2,206.8,152,206.7,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.9,154.3v-0.1h-0.1L211.9,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212,154.2l-0.1-0.1C211.9,154.1,212,154.2,212,154.2L212,154.2l-0.1-0.1C211.9,154.1,212,154.2,212,154.2 L212,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.8,154.1c0.1,0,0.2,0.1,0.2,0S216.8,154,216.8,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,152.8c-0.1-0.1-0.1,0-0.1,0.1l0,0L208.4,152.8c0,0.1,0.1,0.3,0.2,0.3S208.5,153,208.4,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,154.1l-0.2-0.2c0,0.1,0,0.1-0.1,0C210.5,154,210.6,154,210.7,154.1h-0.1 C210.6,154,210.6,154,210.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.9,156.3c0.2,0.2,0.4,0.3,0.6,0.4c0-0.1-0.4-0.3-0.4-0.3s0-0.2-0.2-0.2V156.3c-0.1-0.1-0.1-0.1,0-0.2 c0,0,0,0,0,0c-0.1,0-0.3-0.2-0.3-0.2s-0.4-0.4-0.3-0.5c0.1,0.1,0.1-0.2,0.2,0.1c0-0.1-0.3-0.3-0.3-0.5l0.1,0.1 c-0.1-0.2,0.1-0.2,0-0.4l0.1,0.1c0,0,0.1,0,0-0.1l0,0c-0.1-0.1,0-0.1,0-0.1s-0.3-0.1-0.3-0.3H211c0-0.1-0.1-0.2-0.2-0.3 c0,0.1-0.1,0-0.1,0l0,0c0,0-0.2,0-0.1-0.1v0.1c-0.1-0.1-0.1-0.2,0-0.1l-0.2-0.2c0.2,0.2-0.2,0.2,0.2,0.4c0.1,0.1,0.2,0.3,0.3,0.3 s0.2,0.2,0.1,0.2l-0.1-0.2v0.1c-0.2-0.2-0.4-0.2-0.6-0.4s0-0.2-0.1-0.3l-0.1,0.1v0.2L210,154c-0.1,0.1,0.1,0.1,0.2,0.2 c-0.1,0,0.1,0.2,0,0.2c0.1,0.2-0.1,0.1,0.1,0.3l0,0l0.3,0.3c0.1,0,0.1-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.2-0.2s0.2,0.1,0.1,0l-0.2-0.1 c0-0.2,0.2,0,0.2-0.1v0.1h0.1l-0.1,0.1c0.1,0,0.2,0.2,0.3,0.2h-0.1c0.2,0.2,0.4,0.4,0.6,0.5c0,0.1-0.2,0-0.2,0.1s-0.1-0.2-0.1-0.1 c0.2,0.1,0.2,0.2,0.2,0.3h-0.1l0.1,0.1v-0.1c0.1,0.1,0.2,0.3,0.3,0.4l0,0l0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2l0,0 C211.6,156.2,211.8,156.4,211.9,156.3l0.1,0.1C211.8,156.4,211.8,156.3,211.9,156.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,154.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "213.7,154.5 213.9,154.6 213.9,154.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,154.2L211.2,154.2C211.3,154.2,211.1,154,211.2,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,152.5l0.1,0.1L207.6,152.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.3,154.3L219.3,154.3c-0.1,0-0.1-0.1-0.2,0l-0.1-0.2l0,0c-0.1-0.1-0.1,0.1-0.2,0h0.1 c-0.2,0-0.1-0.2-0.3-0.2h-0.1l0.1,0.1c-0.1-0.1-0.1-0.1-0.2-0.1c0.1,0,0.2,0.1,0.1,0.1l-0.1-0.1l0.1,0.2l0,0c0.1,0,0.2,0.1,0.1,0.1 s0.1-0.1,0.1,0c0,0.1,0.5,0.2,0.3,0.3c0,0.1,0-0.1,0.1,0l0,0C218.9,154.3,219.3,154.4,219.3,154.3s0.1,0.1,0,0.1l0,0 c0,0.1,0.1,0,0.1,0.1H219c0.2,0,0.2,0.1,0.3,0.2l-0.1,0.1c0-0.1-0.1,0-0.2,0c0.1,0.1,0.2,0.1,0.4,0.1l0,0c0.1,0.1,0.2,0,0.3,0.1 v0.1c0.1,0,0-0.1,0-0.1c-0.2,0-0.2-0.1-0.3-0.1h0.2c0.1,0-0.2-0.1-0.1-0.1h0.1c0,0-0.1,0,0-0.1c0.1,0.1,0.1,0,0.2,0l0,0 c0.1-0.1,0.1-0.1,0.2,0c0,0,0,0,0,0l0,0c0.1,0,0.2,0.1,0.3,0.1c-0.1,0-0.3-0.1-0.3-0.2s0.2,0,0.2,0.1c0-0.1-0.2-0.1-0.2-0.2 c0-0.1,0,0.1,0,0.1c-0.2,0-0.1-0.2-0.3-0.2h-0.2c-0.1,0,0-0.1-0.1-0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0h-0.1c0.1,0,0.1,0,0.2,0.1 h-0.2l-0.1-0.1h0.1C219.5,154.5,219.5,154.4,219.3,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.9,152.7L207.9,152.7C207.8,152.8,207.9,152.8,207.9,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,154.4L211.4,154.4c0-0.1,0-0.1-0.1-0.1l0,0C211.2,154.3,211.3,154.3,211.4,154.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "218.2,154.1 218.1,154 218.1,154.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214,154.7L214,154.7C214,154.8,213.9,154.7,214,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,153.2l-0.1-0.2C208.2,153,208.2,153.1,208.2,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208,153.2c0-0.1-0.1-0.2-0.1-0.3h0.1c0-0.1,0-0.1-0.1-0.1l0,0c0.1,0.2-0.1,0,0,0.2 C208,153,208,153.1,208,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.2,153.7c-0.1-0.1-0.1-0.3-0.3-0.3C208.9,153.6,209,153.6,209.2,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.4,153C207.4,152.8,207.5,153,207.4,153s0.1-0.3-0.1-0.4l0.1,0.1c-0.1-0.2,0,0.1-0.1,0.1l-0.1-0.2 c0-0.1,0,0.1-0.1,0c0,0.1,0.1,0.2,0.1,0.3v-0.1L207.4,153z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.5,154.7c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0.1,0,0.2,0.1 C212.6,154.8,212.5,154.8,212.5,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.5,154.7h0.1c-0.1-0.1-0.1-0.1-0.1-0.2l0,0c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0v-0.1c-0.1,0,0,0.1-0.2,0 C211.3,154.5,211.5,154.6,211.5,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.6,153.8c-0.1,0,0,0.1,0,0.1V153.8c0,0.1,0,0.1,0.1,0.1C209.6,153.9,209.6,153.8,209.6,153.8 C209.6,153.8,209.6,153.8,209.6,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,153.8c-0.1-0.1-0.2-0.4-0.3-0.4v0.1l-0.1,0.1C208.7,153.5,208.8,153.7,208.9,153.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "210.1,154.1 210.1,154.1 210.2,154.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,153.5c0,0.1,0.1,0.1,0.1,0.2c-0.1-0.1-0.1-0.2-0.2-0.4C208.3,153.3,208.4,153.5,208.4,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.6,154c-0.1,0,0,0,0,0.1C209.6,154,209.8,154.1,209.6,154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.8,154.3v-0.2l0,0c0.1,0,0,0.1,0,0.1l-0.1-0.1C209.7,154.2,209.7,154.2,209.8,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,153.5l0.1-0.1l-0.1-0.1C208.3,153.4,208.1,153.4,208.2,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.4,154.5c-0.1,0,0.1,0.1,0.1,0.1h0.1C217.5,154.6,217.5,154.6,217.4,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214,155c-0.1-0.1-0.1,0-0.1,0H214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.1,153.4c0-0.1,0-0.1-0.1-0.1l0,0C208,153.3,208.1,153.4,208.1,153.4L208.1,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.4,155h-0.1c0,0.1,0.3,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0C215.5,155.1,215.5,155,215.4,155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,153.2L207.6,153.2C207.6,153.1,207.5,153.1,207.6,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,155.5c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0C212.2,155.5,212.3,155.5,212.3,155.5L212.3,155.5 c-0.1-0.1-0.1-0.1-0.1-0.2l0,0l-0.1-0.2h0.1l-0.4-0.4l0.2,0.2h-0.1c0,0.1,0.2,0.1,0.2,0.2c0,0.1,0,0.2,0.1,0.3 c-0.1-0.1-0.1,0-0.1,0l0,0c-0.1-0.1-0.1,0-0.3-0.1h-0.1c0.1,0.2,0.4,0,0.3,0.2c0.1,0,0.2,0,0.1-0.1c0.2,0,0.1,0.1,0.1,0.2v0.1 C212.3,155.6,212.3,155.6,212.3,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,155.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,155.3c-0.1-0.1,0-0.1-0.1-0.1s0.3,0.2,0.2,0.3h-0.1v0.1c0.2,0.1,0.4,0.4,0.6,0.4c0-0.1-0.2,0-0.2-0.2 c0-0.2,0.1-0.1,0-0.2c-0.1-0.1-0.1,0.2-0.3-0.1l0,0C211.7,155.4,211.7,155.3,211.6,155.3L211.6,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,154.1l0.1,0.2c0.1-0.1-0.1-0.2-0.1-0.3l0.1,0.1c0-0.1,0-0.1-0.1-0.1l0,0V154.1c-0.2,0-0.1-0.3-0.3-0.4 C208.5,153.8,208.6,153.9,208.7,154.1C208.8,154.2,208.7,154,208.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.8,154.5h0.2C218.9,154.5,218.8,154.4,218.8,154.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.4,155 211.5,155 211.4,154.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.4,153.3c-0.1-0.1,0,0.1-0.1,0c0,0.1,0,0.2,0.1,0.2s0.1,0,0.2,0C207.5,153.5,207.6,153.5,207.4,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.7,155.2L210.7,155.2c-0.1-0.1-0.2-0.1-0.2-0.2v0.1c0.1,0,0.1,0.1,0.2,0.2 C210.7,155.2,210.9,155.2,210.7,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.4,154.8c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l0,0l0,0C209.2,154.8,209.3,154.8,209.4,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.1,154.8c-0.2-0.1-0.1-0.2-0.2-0.3c0.1,0.1,0,0.1,0.1,0.1S209,155,209.1,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,156.7c-0.1,0,0,0.1,0.1,0.2h0.1v0.1c0.1,0,0.3,0.2,0.3,0.2s0-0.1,0.1,0c0.1,0.1,0-0.1-0.1-0.1 c0.2,0.1,0,0,0.1,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0v-0.1c0.1,0.1,0.1,0.1,0.2,0.1h0.1c-0.1-0.2-0.2-0.2-0.3-0.2V157 c-0.1,0,0,0.1,0,0.1l0,0l0.1,0.1c-0.1,0-0.2,0-0.2-0.1c0.1-0.1-0.2-0.3-0.1-0.5c-0.1,0-0.1-0.2-0.1-0.1c-0.2-0.3,0.3,0,0-0.3 c-0.2-0.1-0.3-0.3-0.5-0.5c0,0,0-0.1,0.1,0l-0.1-0.1h-0.1l-0.2-0.2l0,0c-0.1-0.1-0.2-0.1-0.3-0.3c-0.2,0-0.2-0.1-0.4-0.4 c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2v0.1l-0.1-0.1c0.1,0.1,0.2,0.3,0.1,0.3c0.1,0.1,0.1,0.2,0.2,0.2s-0.1-0.2,0-0.2 c0.1,0.2,0.2,0.3,0.3,0.4l0,0l0.1,0.1V155l0.3,0.3c-0.1-0.1-0.2,0-0.1,0h0.1v0.2l0,0c0.1,0.1,0.2,0.2,0.2,0.3 c-0.2-0.1-0.2,0.1-0.2,0.1s-0.2-0.2-0.3-0.2l0.2,0.3c0.1,0,0.2,0,0.2-0.1c0.1,0.2,0.1,0,0.2,0.2c0,0,0,0.2-0.2,0.1l-0.1-0.1 c0,0.1,0,0.1,0.1,0.1l0,0c0.1,0,0.2,0.1,0.3,0.2v-0.1C210,156.5,209.9,156.7,210,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210,156.7l-0.1-0.1C209.9,156.7,209.9,156.7,210,156.7L210,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.8,157.5c-0.1,0-0.1,0,0,0.2c0.1-0.1,0.1,0.1,0.2,0.1l-0.1-0.1c0,0,0.2,0,0.1-0.1c0,0.1-0.2-0.1-0.3-0.1 C210.8,157.4,210.8,157.4,210.8,157.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "220.8,154.4 220.7,154.5 220.8,154.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.9,156L213.9,156c-0.1-0.1,0-0.1-0.1-0.2C213.8,155.9,213.8,155.9,213.9,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.4,154.8h0.1c0.1,0.1,0.1-0.1,0.1-0.1s-0.2,0-0.1-0.1c-0.2,0.1-0.4-0.2-0.3,0l-0.1,0.1 C221,154.8,221.3,154.8,221.4,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.3,155.3C218.2,155.3,218.2,155.4,218.3,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216,155.8l0.2,0.1C216.1,155.9,216.1,155.8,216,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.2,156.7c0.1,0,0.1,0,0.2,0.1c-0.2-0.1-0.3-0.2-0.5-0.3l0,0c0-0.1-0.1-0.1-0.1-0.2c0,0.1,0,0.1-0.1,0.1 l0,0c0-0.1,0-0.1,0.1-0.1c-0.1-0.1-0.1,0-0.2,0s-0.5-0.2-0.6-0.3V156h-0.1c0,0.1,0.2,0.1,0.2,0.2c0,0.1,0.1,0,0.3,0.1 c0,0,0,0.1-0.1,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1c0.1,0.1-0.2,0-0.2,0 s0.2,0.2,0.3,0.2c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0.1,0,0.2,0.2,0.3,0.2s0-0.1-0.1-0.2C215.7,156.6,215.9,156.7,216.2,156.7 L216.2,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.4,156c0-0.1,0.1,0,0.1,0l-0.2-0.1C212.3,156,212.4,156,212.4,156L212.4,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.3,155.3c0-0.1,0.1,0,0.1,0H219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.7,155.3c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0L219.7,155.3c0.2,0.1,0.3,0.1,0.2,0.1c0.1,0,0.1,0,0.1,0.1v-0.1 c0.2,0,0.4,0.2,0.4,0.1c0-0.1-0.1,0-0.1-0.1s0,0.1-0.1,0l-0.3-0.3c0,0.1-0.1,0-0.1,0.1c-0.2,0,0-0.1-0.1-0.1V155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.1,155.2c0.4,0.1-0.2,0.2,0.2,0.3C220.1,155.4,220.5,155.3,220.1,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.1,155.1c0-0.1-0.2,0-0.3-0.1C220.8,155.1,221,155,221.1,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.9,155.2L208.9,155.2l-0.1-0.1C208.8,155.1,208.9,155.2,208.9,155.2C208.9,155.2,208.9,155.2,208.9,155.2z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.4,154 206.5,154.1 206.4,153.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.3,155.1c0-0.1-0.1,0-0.2-0.1v0.1H221.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.5,155.5c0,0.1,0.3,0.1,0.3,0.2c0,0.1,0.2,0.1,0.3,0.1v-0.1l0,0c0-0.1-0.1-0.1-0.3-0.2 C219.7,155.6,219.6,155.4,219.5,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218,158.1L218,158.1c0.2,0,0,0,0.2,0.1v0.1h0.2c0.1,0,0.1,0,0.1,0.1v-0.1h0.1c-0.1,0-0.1-0.1,0-0.1 s0.1,0,0.2,0.1v-0.1c-0.1,0-0.1-0.1-0.1,0c0-0.1-0.3-0.2-0.3-0.3c0-0.1,0,0.1-0.2,0v-0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.3-0.2-0.3-0.3l0.3,0.1c0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0,0.1-0.2-0.2-0.2h0.4c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0 c0-0.1,0.2,0.1,0.3,0c-0.1,0-0.1-0.1-0.2-0.1h-0.1c-0.2-0.1,0.1,0,0-0.1l0,0c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l0,0 c-0.1,0-0.2,0-0.2-0.1l0,0c-0.1-0.1-0.2,0-0.3-0.1c-0.1-0.1,0.2,0.1,0.1,0.1s-0.3-0.1-0.4-0.2h-0.1c-0.1,0-0.1-0.1-0.2-0.1v-0.1 c0,0.1-0.2-0.1-0.3-0.1h-0.1c0.1,0,0,0,0-0.1l0,0c0.1,0.2-0.3-0.1-0.2,0c0.1,0,0.1,0,0.2,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2 c0.1,0.1-0.1,0,0-0.1c0.2,0.1,0.1,0.1,0.3,0.3h0.2c0,0.1,0,0.1,0.1,0.1c0.1,0,0,0.1-0.1,0.1l-0.1-0.1c0.1,0,0,0.1,0.1,0.1l0,0 c0.1,0,0.1,0.1,0.2,0.2h-0.1c0.1,0,0,0,0,0.1s-0.1,0-0.2-0.1c-0.1-0.1,0.1,0,0-0.1h-0.1c0.1,0,0,0.1,0.1,0.1s-0.2-0.1-0.3-0.2 s0.1,0.1,0,0.1s0-0.1-0.1-0.2c0.1,0.1,0.2,0,0.2,0.1c0-0.1,0-0.1-0.1-0.1l0,0h-0.2c0.1,0,0,0.1,0,0.1s-0.1,0-0.3-0.1 c0,0.1,0.2,0.1,0.2,0.2h0.1c0.2,0,0.4,0.1,0.4,0.2c0-0.1,0.3,0.1,0.4,0.1c0.3,0.1,0.2,0.3,0.5,0.3l0,0 C217.7,157.9,218,157.9,218,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.7,155.4C208.7,155.3,208.9,155.4,208.7,155.4C208.8,155.4,208.5,155.2,208.7,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.2,155.1h0.1c-0.1,0,0.3,0.1,0.1,0.2c0.2,0.1,0.3,0,0.4,0.1v0.1h0.1l0.1,0.1c0-0.1-0.2-0.1-0.1-0.2 l0.1,0.1l-0.1-0.1h-0.1c0,0-0.2-0.1,0-0.1h-0.2c0-0.1-0.1-0.1-0.2-0.1C221.3,155,221.3,155.3,221.2,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.2,155.6l0.1,0.1L209.2,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,156.7v-0.1h-0.2C214.9,156.6,215,156.6,215,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,156.6l-0.1-0.1L211.8,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.4,155.5L208.4,155.5c0.1,0.1,0.2,0.3,0.2,0.2C208.4,155.7,208.5,155.5,208.4,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.3,156.8c0,0-0.1-0.2-0.2-0.1C215.3,156.7,215.2,156.8,215.3,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.2,157L212.2,157c0.3,0.1,0.2,0.2,0.4,0.3l-0.2-0.1c0.1,0.1,0,0.1,0.2,0.1s0-0.1,0-0.2 c0.3,0.3,0.4,0.2,0.7,0.5h0.2c0-0.1,0-0.1-0.1-0.1l0,0c0.2,0.2,0.5,0.1,0.7,0.3c0-0.1-0.2-0.1-0.2-0.2c-0.2-0.1-0.3-0.1-0.5-0.1 l0.1-0.1c-0.1-0.1-0.2,0-0.3-0.1l0,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.2,0,0.1,0.2-0.2,0.1c0.1-0.1-0.2-0.1-0.1-0.2 c-0.2,0-0.4-0.2-0.6-0.3S212.3,157,212.2,157z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "212.3,156.7 212.5,156.8 212.4,156.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "211.2,156.5 211.3,156.6 211.3,156.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "206.5,154.6 206.6,154.8 206.6,154.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.2,156.8c0.1,0,0.1,0.1,0.2,0.1C215.3,156.9,215.3,156.9,215.2,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.7,155.8C220.8,155.8,220.7,155.7,220.7,155.8c0.2,0.1,0.3,0,0.5,0.1h0.1c0.1,0-0.1-0.1-0.1-0.1 s-0.1,0.1-0.2,0c0-0.1,0-0.1,0.1-0.1l0,0c-0.1-0.1-0.3,0-0.4-0.1V155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208,156l0.2,0.2c0-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.2-0.1c-0.1,0,0.2,0.1,0.1,0.2h0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.1,156.8H216C216,156.8,216.1,157,216.1,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.2,157"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,157l0.2,0.2v-0.1c0,0,0.2,0.1,0.2,0c0-0.1-0.2-0.1-0.3-0.2C210.9,156.9,210.9,156.9,210.9,157 C210.9,157,210.9,157,210.9,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.7,156L220.7,156c0,0.1,0,0.1,0.1,0.1l0,0L220.7,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.4,156.5l-0.2-0.2L209.4,156.5L209.4,156.5C209.3,156.4,209.5,156.5,209.4,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.5,156.1c0.1,0,0.1,0.1,0.3,0.1C220.7,156.2,220.6,156.1,220.5,156.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "222.1,155.7 222.1,155.7 222.2,155.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.2,157.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0C212.5,157.4,212.3,157.5,212.2,157.4 C212.2,157.4,212.2,157.4,212.2,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.1,156.1L221.1,156.1C221.2,156,221.1,156,221.1,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.9,156.4c0.1-0.1,0.1-0.1,0.2,0c0,0,0,0,0,0c0.1,0-0.1,0-0.1-0.1c0.1-0.1,0.1-0.1,0.2,0c0,0,0,0,0,0v-0.1 h0.1c0-0.1-0.3-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1C220.7,156.3,220.9,156.3,220.9,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.3,156.1h-0.1C221.3,156.2,221.3,156.1,221.3,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.8,157.6c0.2,0.1,0.1,0,0.2,0.1L212.8,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.6,156c0,0.1,0,0.1,0.1,0.1L221.6,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.7,157.6l-0.1-0.1L212.7,157.6C212.6,157.6,212.7,157.7,212.7,157.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "216.6,157.4 216.5,157.4 216.6,157.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.6,157.7c-0.2-0.2-0.4-0.6-0.6-0.6c0,0.2,0.3,0.1,0.3,0.3l0,0c0.1,0.2,0.2,0.3,0.2,0.5l0.2,0.1v-0.1 c0.1,0.1,0.1,0,0.2,0.1C210.8,158,210.7,157.8,210.6,157.7L210.6,157.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.9,157.2 218,157.2 217.9,157  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.6,157.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.7,157.2 217.9,157.3 217.8,157.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.7,157.8c0-0.1,0-0.1-0.1-0.1l0,0C215.7,157.7,215.7,157.7,215.7,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.5,157.3L218.5,157.3C218.4,157.2,218.5,157.2,218.5,157.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "209.4,157.3 209.4,157.3 209.2,157  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.7,157.2h-0.1c-0.1,0,0.3,0.2,0.2,0.2l0,0c0,0,0.1-0.1,0-0.1c0.1,0.1,0-0.1,0.1,0v-0.1 C218.9,157.4,218.7,157.2,218.7,157.2S218.7,157.3,218.7,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.2,157.6l-0.1-0.1v0.1H217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.9,156.5c-0.1,0-0.2-0.1-0.3,0H221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.2,157.8l0.3,0.2v-0.1h0.1l0.1-0.1c-0.1,0-0.2,0-0.2-0.1C216.4,157.9,216.2,157.7,216.2,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.5,157c0.1,0.1,0.3,0.2,0.5,0.2C219.8,157.2,219.6,157.1,219.5,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.5,157.4L209.5,157.4c0.1,0.1,0.2,0.2,0.3,0.2C209.7,157.6,209.6,157.5,209.5,157.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "218,157.5 218,157.6 218.1,157.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "216,158 216,158 215.9,157.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213,158.7c0.2,0.1,0.4,0.1,0.5,0.2h-0.3l0.3,0.3c-0.1-0.1,0.1-0.1-0.1-0.2h0.1c-0.1,0-0.1,0-0.1-0.1 c0,0,0,0,0,0c0.1,0.1,0-0.1,0.1-0.1c-0.2,0,0-0.1-0.1-0.1c-0.3-0.1-0.7-0.2-0.8-0.4c0,0.1-0.1,0-0.2,0c0.1,0,0-0.1-0.1-0.2 c0,0.1-0.2-0.1-0.1,0l0,0C212.4,158.3,212.9,158.5,213,158.7l-0.6-0.3c0.1,0.2,0.5,0.3,0.7,0.5h0.1L213,158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.6,155.5L225.6,155.5c-0.1-0.1-0.1-0.1-0.2-0.1h-0.1C225.3,155.5,225.5,155.6,225.6,155.5 C225.6,155.5,225.6,155.5,225.6,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.1,156.8c0.1,0,0.1,0.1,0.1,0l0.1,0.1h0.3C221.4,157,221.2,156.7,221.1,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221,157L221,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,158.1c0,0.2-0.2-0.2-0.2,0l0.2,0.2C211.2,158.2,211.3,158.1,211.2,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.2,157.5v0.1c0-0.1,0.2,0.1,0.3,0.1c0-0.1,0-0.1-0.1-0.1l0,0c0.1,0.1,0.3,0,0.4,0 C219.5,157.5,219.5,157.6,219.2,157.5C219.3,157.4,219.3,157.5,219.2,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.3,158.2L214.3,158.2c0.1,0.2,0.2,0.3,0.4,0.3l-0.1-0.1c0,0.1-0.1,0-0.2,0c0.1,0,0-0.1,0-0.2H214.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225,156h0.4c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0h0.1c-0.2,0,0.1,0-0.1-0.1c0,0.1,0,0.1-0.1,0.1 c-0.2-0.2-0.4,0-0.6-0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0v0.1C224.8,156,224.9,156,225,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211,158.1c0,0.1,0.1,0.1,0.2,0.1C211.1,158.2,211.1,158.1,211,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.7,157L221.7,157c0.1-0.1-0.1-0.1-0.1-0.2C221.5,157,221.7,157,221.7,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,158.4l-0.1-0.1C214.9,158.3,214.9,158.4,215,158.4L215,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.8,158.1h0.1c-0.1-0.1,0-0.1-0.1-0.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "226.1,155.6 226,155.5 226,155.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.6,158.5l0.1,0.1h0.1C213.7,158.4,213.7,158.5,213.6,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.8,156.2c0.1-0.1-0.1,0,0-0.1c-0.1,0-0.1-0.1-0.2-0.1s0.2,0.2,0.1,0.2H224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.8,158.5c-0.1-0.1-0.1-0.1-0.2-0.1l0.1,0.1H214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.4,158.4l0.1,0.1h0.1C215.5,158.5,215.4,158.4,215.4,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,158.6c0.1,0,0,0.1,0.2,0.1L215,158.6C214.9,158.5,215,158.5,215,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.4,159.7c0.2,0.1-0.2,0,0,0.2l0,0c0.1,0,0.1,0,0.2,0.1l0,0c-0.1,0-0.2,0-0.2-0.1 C215.3,159.8,215.3,159.7,215.4,159.7c0.1-0.1,0.2,0,0.3,0.1c0,0,0,0,0,0v-0.1H215.4L215.4,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.3,160.6l-0.1-0.1L217.3,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.4,160.6c0.1-0.1,0.3,0.1,0.4,0l-0.2-0.1c-0.2-0.1,0.1-0.1-0.2-0.2l0,0c-0.2-0.1-0.3,0-0.5-0.1 c0,0,0.1,0,0,0.1h0.2L218.4,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.1,160.8l0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1C217.1,160.7,217.1,160.7,217.1,160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216,159.8c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0L216,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,158.6c0.1,0,0.2,0,0.2,0.1v-0.1c-0.3-0.2-0.2,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.4,0.2 C212.5,158.8,212.2,158.7,212.3,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.1,158.2L217.1,158.2C217.2,158.3,217.2,158.2,217.1,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226,155.7c0,0.1,0,0.1,0.1,0.1l0,0h0.2C226.2,155.7,226.1,155.8,226,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.2,158.5l0.1,0.1l0,0l0.1,0.1l-0.2-0.1c0.1,0.1,0.2,0.1,0.3,0.1C211.4,158.6,211.3,158.5,211.2,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.1,157.4c0,0-0.2,0-0.2-0.1l0,0c-0.1,0-0.2,0-0.3-0.1c0.1,0.1,0.1,0.1,0.3,0.1c0.1,0,0.1,0,0.1,0.1 c0,0,0,0,0,0C222.2,157.5,221.9,157.4,222.1,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.9,157.6L220.9,157.6c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0L220.9,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.7,158.1h0.1v0.1l0,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0l0,0c0.1,0,0.1,0.2,0.2,0.1l0,0c0-0.1,0.1,0,0.2,0 v-0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0C219.2,158.2,218.9,158,218.7,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218,158.3l0.1,0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0H218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.8,158c-0.1,0.1-0.1-0.1-0.2,0c-0.1,0.1-0.3-0.1-0.1-0.1c-0.2-0.1-0.3,0-0.3-0.1c0-0.1-0.3-0.1-0.3-0.2 c-0.2,0-0.5,0-0.7-0.1l0,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0l0,0c0.3,0.1,0.6,0.2,0.9,0.3v0.1c0.1,0,0.1,0.1,0.2,0.1 c0.1,0,0,0,0.1,0h-0.1c0.2,0,0.3,0.1,0.5,0.1L222.8,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.7,158.8l0.2,0.1h-0.1l0.1,0.1C213.7,159,214.3,159,213.7,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.2,158.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.7,155.8c0,0,0.1-0.1-0.1-0.1L226.7,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.6,157.7l0.2,0.1l0,0c0.1,0,0.1-0.1,0.2,0s0.1,0.1,0,0.1l-0.1-0.1c-0.1,0.1-0.1,0-0.3,0 c0.1,0.1,0.6,0.1,0.5,0.2h0.1c0-0.1-0.1-0.1,0-0.2s0.1,0,0.1,0.1c0.2,0,0.3-0.1,0.4,0l0,0c0.2,0,0.3,0.1,0.4,0.1l0.1-0.1l-0.1-0.1 H224v0.1c-0.1,0-0.1,0-0.1-0.1h-0.1c-0.1-0.1,0.2-0.1,0-0.1c0,0.1-0.1,0-0.1,0.1c-0.2,0,0,0-0.1-0.1l0,0c-0.1-0.1-0.4-0.1-0.3-0.2 h-0.2c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0l-0.1-0.1v0.1H223c0,0,0.2-0.1,0-0.1l0,0c0-0.1,0-0.1-0.1-0.1l0,0h-0.2 c-0.1,0-0.3-0.1-0.4-0.1C222.3,157.5,222.6,157.6,222.6,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.6,158.8c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0C216.4,158.8,216.5,158.8,216.6,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.1,159.1h-0.2l-0.1-0.1c0,0.1,0.2,0.1,0.2,0.2v-0.1C214,159.2,214,159.2,214.1,159.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "219.6,158.4 219.6,158.4 219.5,158.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.7,159.1l-0.1-0.1h-0.2C216.4,158.9,216.5,159.1,216.7,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.5,159c0,0.1,0.3,0.1,0.2,0.1c0.2-0.1,0.2,0.1,0.3,0l0.1,0.1c0-0.1,0.1,0,0.2-0.1 c-0.1-0.1-0.3-0.1-0.2-0.2h-0.2c0,0-0.1-0.1,0-0.1c-0.1-0.1-0.4,0-0.5-0.1h-0.1c0.2,0,0.2,0.1,0.3,0.2c-0.3-0.1-0.5-0.1-0.8-0.2 c-0.1,0.1,0.1,0.1,0.1,0.2C218.1,158.9,218.4,159,218.5,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.5,156.2c-0.1,0,0-0.1-0.1-0.1L226.5,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.5,159.1c-0.1,0-0.1-0.1-0.2-0.1C210.4,159,210.4,159,210.5,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.9,159.5c-0.1,0-0.3-0.1-0.4-0.2c0,0.1,0,0-0.1,0c0.1,0.1,0.3,0.2,0.3,0.3v-0.1l0.1,0.1 C213.6,159.5,213.9,159.5,213.9,159.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "219.4,158.6 219.4,158.6 219.3,158.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.7,157c-0.3,0.1-0.7-0.3-1-0.1c0.2,0.1,0.3,0.1,0.5,0.2h0.1c-0.1,0-0.1-0.1,0-0.1c0.1,0,0,0.1,0.1,0.2 s-0.1-0.1,0-0.1s0,0.1,0.1,0.2c0.1-0.1,0.2,0.1,0.3,0c0,0.1,0,0.1,0.2,0.1c0.2,0,0.2,0,0.3-0.1c-0.2,0-0.4-0.1-0.5-0.2 C225.8,157.2,225.9,157.2,225.7,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227,157.5c-0.2-0.1-0.4-0.1-0.6-0.1c0.1,0.1,0.4,0.1,0.5,0.2S227.2,157.7,227,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220,158.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.1,159.4c0.1,0,0.2,0,0.2,0.1C214.2,159.4,214.1,159.3,214.1,159.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "213.3,159.4 213.3,159.4 213.2,159.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.3,158.5L220.3,158.5l-0.1-0.1C220.2,158.4,220.2,158.5,220.3,158.5L220.3,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226,156.8h0.1l0.1,0.1C226.3,156.8,226,156.8,226,156.8h0.2l-0.3-0.1v0.1C225.9,156.7,225.9,156.8,226,156.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.3,158.6c0.2,0,0.2,0.1,0.4,0.1l0,0c0.1,0,0.2,0,0.2,0.1v-0.1c0-0.1-0.2,0-0.2-0.1 C220.7,158.5,220.5,158.5,220.3,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.9,159c-0.1-0.1-0.2-0.1-0.3-0.2c0.1,0.1,0.2,0,0.3,0c-0.1,0-0.1,0-0.2-0.1l0,0l-0.2-0.1v0.1 c-0.1-0.1-0.1,0-0.2,0c0.1,0.1,0.1,0.1,0.2,0.1c-0.1,0,0,0.1-0.2,0c0.1,0.1,0.2,0,0.2,0.1L219.9,159z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220,159.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.9,157c-0.1,0-0.2-0.1-0.3-0.1C225.7,157,225.8,157,225.9,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.8,156.1v0.1C227.9,156.2,227.8,156.1,227.8,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218,159.1L218,159.1c0,0.1,0,0.1,0.1,0.1l0,0C218.1,159.2,218,159.1,218,159.1C218,159.1,218,159.1,218,159.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.9,159.6v0.1c0.1,0,0-0.1,0.2,0c0,0.1,0,0.1,0.1,0.1l0,0c0,0-0.1-0.1,0-0.1l-0.1-0.1 C215,159.7,214.9,159.7,214.9,159.6C214.9,159.6,214.9,159.6,214.9,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.9,160.1c0.1-0.1,0-0.1-0.1-0.2c-0.1-0.1,0,0,0,0.1s-0.2-0.2-0.3-0.1l0,0 C214.6,159.9,214.8,160,214.9,160.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.8,159.4 218,159.4 217.9,159.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,157.2c-0.1,0-0.4-0.2-0.4-0.1c0,0.1,0,0.1,0,0.1c0.3,0-0.2-0.1,0.1-0.1c0,0.1,0.2,0.1,0.2,0.1l0,0h0.2 C226.4,157.2,226.3,157.3,226.4,157.2L226.4,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.5,157.3L226.5,157.3c0.2,0.1,0.3,0,0.3,0.1c0.1-0.1-0.2,0-0.1-0.1s0.2,0,0.2,0s-0.1-0.1,0-0.1h-0.4V157.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.9,158.2C222.9,158.1,223.1,158.2,222.9,158.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "223.3,158.1 223.3,158.2 223.5,158.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.1,157.9c0.1,0,0.2,0,0.2,0.1C224.3,157.9,224.2,157.8,224.1,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.5,159.5c-0.2,0-0.2-0.1-0.4-0.2c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.2-0.1-0.6-0.1-0.7-0.2 c-0.1-0.1,0.1,0,0-0.2l0,0c0,0-0.1-0.1,0-0.1c-0.1,0-0.3,0-0.3-0.1v0.1c-0.3-0.1-0.6-0.2-0.8-0.4h-0.3c-0.1-0.1-0.1-0.1-0.2-0.1 l0.1-0.1l0,0c0-0.1,0-0.1,0.1-0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0h-0.2c0.1,0.1,0.3,0,0.3,0.1v-0.1c0.1,0.1,0.2,0.1,0.3,0.2h-0.1 c0.1,0,0.1,0,0.1-0.1s-0.3-0.1-0.5-0.1l0,0c0-0.1-0.2,0-0.3-0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0c-0.2,0-0.3,0-0.4-0.1h0.1 c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0.1,0,0.1,0.1l0,0c0.1,0,0,0.1,0,0.1s-0.2-0.1-0.3,0c-0.2,0-0.3-0.1-0.4-0.2v0.1h-0.1 c0.1,0.1,0.2,0.1,0.3,0.1h0.1c0,0.1,0,0.1,0.1,0.1l0,0h-0.1c0.2,0-0.1,0.1,0.2,0.2l0,0c0.1,0,0.2,0.1,0.3,0.1l0,0 c0.2,0,0.4,0.1,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.3c0-0.1,0.2,0,0.1-0.1c0.1,0,0,0.1,0.2,0c-0.1,0.1,0.1,0.1,0.1,0.2h0.1 c-0.2,0,0.1,0,0-0.1c-0.1-0.1-0.1,0-0.1-0.1c0-0.1,0.2,0,0.2,0.1l0,0c0.1,0,0.2,0,0.2,0.1h0.2c0.1,0.1,0.4,0,0.4,0.1h-0.2 c0.1,0.1-0.1,0-0.2,0.1v-0.1c0,0.1-0.1,0-0.2,0l0,0c-0.1,0-0.1-0.1-0.1,0c0,0.1,0.1,0,0.1,0.1h-0.1l-0.1-0.1l0,0 c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0v0.1c-0.1-0.1-0.4-0.1-0.4,0c-0.1-0.1-0.3-0.1-0.4-0.2v0.1c-0.2,0-0.4-0.1-0.6-0.1v0.1h-0.3 c0.2,0.1,0.3,0.1,0.5,0.2l0,0c0,0.1,0.4,0.1,0.3,0.2c-0.1-0.1-0.4,0-0.4-0.1h-0.1c0-0.1-0.1,0-0.2-0.1v0.1l0,0l-0.2-0.1h-0.1 c-0.2-0.1-0.5-0.1-0.7-0.2h-0.3c0.1,0.1,0.3,0.1,0.4,0.2s0.5,0,0.7,0.2c0,0.1-0.1,0-0.1,0h0.2v0.1c0.1,0,0.2,0,0.3,0.1l0,0 c0.2,0.1,0.8,0,1,0.2l0.2,0.1c0.1,0,0.2,0,0.2-0.1h-0.1c0-0.1,0.2,0,0.1-0.1l-0.1-0.1l0,0c-0.1-0.1-0.3,0-0.4-0.2 c-0.1-0.2,0.2,0,0.3,0l0,0c0,0,0.3,0.1,0.3,0v-0.1c0.2,0.1,0.3,0.1,0.5,0.1l0,0c0.1,0.1,0.3,0,0.3,0.1h0.1c0.3,0,0.4,0.2,0.7,0.1 C227.4,159.6,227.5,159.5,227.5,159.5L227.5,159.5C227.4,159.5,227.5,159.6,227.5,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.7,158.7c0.1,0.2-0.2-0.1-0.2,0h-0.1v-0.1h-0.3c0,0,0.1,0.1,0,0.1H222c0,0,0.1,0.1,0,0.1s0,0-0.2-0.1 l0.1,0.1l-0.1,0.1c0.3,0.1,0.6,0.1,0.8,0.2l0,0C222.8,158.8,222.7,158.7,222.7,158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228,156.5c-0.1-0.1,0.1,0,0.1-0.1h-0.2C227.9,156.5,228,156.5,228,156.5L228,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.9,158.1L223.9,158.1C223.8,158,223.8,158.1,223.9,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.4,157L229.4,157c-0.1-0.2-0.5-0.2-0.5-0.4l0.1,0.1c0.2-0.1,0.4,0.1,0.6,0c0.2-0.1-0.1,0-0.1-0.1 c-0.4,0-0.7-0.1-1.1-0.1c0.1,0.1,0.2,0,0.3,0.1h-0.1c0.2,0,0.2,0.1,0.3,0.1s-0.1,0-0.2,0l0.1,0.1c-0.2,0.1-0.1-0.1-0.2,0 c0-0.1-0.2,0-0.2-0.1c0-0.1-0.4,0-0.4-0.1c-0.2,0-0.1,0.1-0.3,0.1v0.1h-0.1l0.1,0.1h0.1v0.1h-0.2l0.1,0.1h-0.1c0,0.1,0.1,0,0.2,0 h0.1c-0.1,0-0.1-0.1,0-0.1s-0.1,0,0,0.1V157l0,0c-0.1-0.1,0.1-0.1,0.1-0.1l0.1,0.1c-0.3-0.2,0.3-0.1,0-0.2c0.1,0,0.1,0,0.1,0.1 c0.2,0,0.5,0.1,0.7,0.2h-0.1C229,157.1,229.2,157,229.4,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.4,158.3c-0.1,0,0,0-0.1-0.1L223.4,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.2,158.1h0.1C224.2,158,224.2,158,224.2,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.3,158c0.1,0,0.1,0.1,0.2,0.1s0,0,0-0.1H224.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 213.4,
    y1: 160.4,
    x2: 213.2,
    y2: 160.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.9,159.4c0-0.1-0.2-0.1-0.2-0.1L220.9,159.4c0-0.1-0.1-0.1-0.2-0.2l0,0l-0.1-0.1c0,0,0.1,0.1,0,0.1 c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0h-0.2c0.2,0.1,0.4,0.2,0.4,0.1C220.8,159.4,220.9,159.4,220.9,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.2,160.3c-0.2,0,0,0.1-0.2,0.1l0.1,0.1C215.1,160.5,215,160.3,215.2,160.3l0.1,0.1h-0.1l0.2,0.1 C215.4,160.5,215.2,160.4,215.2,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.1,157.4L227.1,157.4l-0.1-0.1C226.9,157.3,227.1,157.3,227.1,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,157.6c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0h0.1L226.4,157.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "220.5,159.5 220.4,159.4 220.3,159.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.8,160.1 217.8,160.1 217.7,160  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.4,156.4c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l-0.1,0.1h0.1C229.4,156.4,229.4,156.5,229.4,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.1,160.7h0.2C215.2,160.8,215.1,160.8,215.1,160.7C215.1,160.7,215.1,160.7,215.1,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.6,160.6c0.1,0.1,0.3,0.1,0.4,0.2c-0.1-0.1-0.2-0.2-0.3-0.2H214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.5,159.7c0-0.1,0.1,0,0.2,0l0,0c-0.1-0.2-0.3-0.2-0.5-0.1C220.4,159.6,220.5,159.6,220.5,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.6,160.7c0.1,0,0.3,0.1,0.3,0c-0.2-0.1-0.3-0.2-0.5-0.2C215.5,160.5,215.5,160.7,215.6,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.2,156.3c0-0.1,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.2-0.3,0C230.2,156.2,230.1,156.3,230.2,156.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "229.7,156.6 229.5,156.5 229.5,156.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.5,159.5c-0.1,0-0.2,0.1-0.3,0l0.4,0.1c-0.1,0,0,0,0,0.1l0,0c0.2,0.1,0.4,0.1,0.6,0.2v-0.1 C221.9,159.7,221.7,159.5,221.5,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.3,160.1h0.2C219.4,160.1,219.4,159.9,219.3,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227,157.7L227,157.7c0.1,0.1,0.1,0.1,0.2,0.1l0.1-0.1C227.2,157.8,227.1,157.7,227,157.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "217.5,160.4 217.5,160.4 217.4,160.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "221,159.8 221,159.8 220.9,159.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.5,159.8c0.1,0,0.1,0,0.1,0.1s0-0.1,0.1,0s0-0.1-0.1-0.1H220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.5,157.7c0.1,0,0.1,0,0.1-0.1C227.6,157.5,227.5,157.6,227.5,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.1,160.8l0.3,0.1L216.1,160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.3,160.4c0,0.1,0.2,0.1,0.2,0.2s0-0.1,0.1-0.1h-0.1C219.4,160.5,219.5,160.4,219.3,160.4 c-0.2,0-0.4-0.1-0.6-0.1C218.8,160.4,219,160.4,219.3,160.4L219.3,160.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "223.4,159.2 223.5,159.2 223.4,159.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.3,157C232.3,157.1,232.4,157.1,232.3,157h-0.1C232.3,157.1,232.3,157.1,232.3,157L232.3,157 C232.4,157,232.3,157,232.3,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.9,157c0.2,0,0.4,0.1,0.6,0.2c0,0,0.1,0,0-0.1c0.2,0.1,0.5,0.2,0.7,0.2c-0.1-0.1,0.1,0,0-0.1l0,0 c0-0.1,0-0.1-0.1-0.1l0,0h0.2c-0.1-0.1-0.3-0.1-0.5-0.2h-0.1c0.1,0,0,0,0-0.1c0,0.1-0.3,0-0.3,0s-0.3-0.2-0.4-0.3s0.1,0,0,0.1h-0.1 c0,0.1,0.2,0,0.1,0.1c-0.1,0-0.1,0-0.2-0.1l0,0l-0.1-0.1c-0.2,0.1-0.2,0-0.4,0.1l-0.1-0.1v0.1l0,0v-0.1c0.1,0.1,0.1,0,0.2,0 c-0.2,0,0.1,0.1,0,0.1h0.2C230.5,157,230.7,157,230.9,157C230.8,157,230.9,157,230.9,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.7,156.6c-0.1-0.1-0.1,0-0.2-0.1C230.5,156.6,230.7,156.5,230.7,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.5,159.5c0,0.1,0.1,0.1,0.2,0.1C222.7,159.5,222.6,159.5,222.5,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.3,158l0.1,0.1L227.3,158l0.3,0.1C227.5,158,227.4,157.9,227.3,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.9,156.5l-0.1-0.1L230.9,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.5,157.8l-0.1-0.1l0,0c-0.1,0-0.2,0-0.3,0.1c-0.1-0.1,0-0.1-0.1-0.1c0,0.1,0.1,0.2,0.2,0.2l0,0h0.2 L228.5,157.8c-0.1,0.1-0.1,0.1-0.2,0.1v-0.1H228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.4,159.6c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0C223.2,159.5,223.3,159.6,223.4,159.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "222.9,159.6 222.9,159.7 223,159.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.4,161.1c-0.1-0.1-0.1,0-0.2,0C217.4,161.1,217.3,161.1,217.4,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.5,158.6c-0.1-0.1-0.1,0-0.1,0H226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223,159.7c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0-0.1-0.1-0.1-0.1s-0.2,0-0.2-0.1C223.2,159.6,223.1,159.7,223,159.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.3,158.3h-0.1l0.2,0.1L227.3,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.2,158.6L226.2,158.6c0.1,0,0.2,0.1,0.1,0C226.4,158.7,226.3,158.6,226.2,158.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "216.9,161.2 217.1,161.3 217,161.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.5,158.3L227.5,158.3c0,0.1,0,0.1-0.1,0.1h0.2C227.6,158.3,227.6,158.3,227.5,158.3L227.5,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.5,159.6c0,0.1,0.1,0.1,0.2,0.1h0.1L223.5,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220,160.7c-0.1,0.1,0,0,0.1,0.1H220c0.1,0,0.3,0.1,0.2,0.1s-0.1-0.1-0.1,0h0.1c0.1-0.1-0.2-0.1-0.1-0.1l0,0 C220.1,160.7,220,160.8,220,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220,160.6L220,160.6l-0.1,0.1c0.1-0.1,0.2,0.1,0.2,0.1l0,0c0.1,0,0.1,0,0.1,0.1l-0.1-0.2h0.2L220,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227,158.7c0.1-0.1-0.1,0-0.1,0S227,158.6,227,158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.1,157.7c-0.1,0-0.2,0-0.3-0.1l0,0c0,0.1-0.3-0.1-0.3,0c0.2,0,0.1,0.1,0.3,0.1v-0.1L230.1,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.2,158.6c-0.1,0-0.2,0-0.1,0.1C227.2,158.8,227.3,158.7,227.2,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.8,158.4C227.9,158.3,227.9,158.4,227.8,158.4L227.8,158.4l0.1,0.1c0.1,0,0-0.1,0.2-0.1 C228.1,158.3,227.9,158.3,227.8,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.6,160.4l0.2,0.1L221.6,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221,160.9L221,160.9c0-0.1-0.4,0-0.5-0.2c-0.1,0,0,0,0,0.1h-0.1c0.1,0.1-0.1,0,0,0.1h0.1 c0.3,0.2-0.2,0.1,0.1,0.2h0.1c-0.1,0-0.1,0-0.1-0.1v0c0.1,0.1,0.3,0,0.4,0.1C221,161.1,221.2,161.1,221,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.3,158.7c0.1,0.1-0.1,0-0.1,0.1L227.3,158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222,160.7h-0.4c0.1,0-0.1-0.1-0.1-0.1l0.1,0.1h-0.1c0.2,0.2,0.6,0.1,0.7,0.3h0.1 C222.2,160.8,222.1,160.8,222,160.7L222,160.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "222.7,160.3 222.7,160.3 222.6,160.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.3,157.9L229.3,157.9C229.4,157.9,229.3,157.8,229.3,157.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "229.8,157.9 229.9,157.9 229.7,157.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.5,160.1c-0.1,0-0.1-0.1-0.3-0.1C224.3,160,224.4,160,224.5,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.7,160.4L222.7,160.4c0,0.1,0.3,0.2,0.3,0.3h0.1c-0.1,0-0.1,0-0.1-0.1v0h0.1 C223,160.6,222.8,160.5,222.7,160.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "230.5,157.9 230.5,157.8 230.4,157.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.4,157L233.4,157c-0.2-0.1-0.4-0.2-0.5-0.3v0.1l-0.2-0.1v0.1h0.2c0,0.2,0.3,0.2,0.6,0.3c0-0.1,0.1,0,0.1,0 V157C233.6,157,233.5,157,233.4,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.6,161.3c0.1,0.1,0.2,0,0.3,0v-0.1c-0.1,0,0,0,0,0.1S220.7,161.2,220.6,161.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.1,159.6c0.1,0,0.3,0.1,0.4,0.1l-0.1-0.1C226.3,159.7,226.1,159.6,226.1,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.5,157.2L232.5,157.2l0.1,0.1h0.1C232.7,157.2,232.6,157.2,232.5,157.2L232.5,157.2l-0.1-0.1 C232.4,157.2,232.4,157.2,232.5,157.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "230.9,158 230.7,157.9 230.8,158  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.6,157.6c0,0.1-0.2,0-0.2,0l0,0c-0.1,0-0.1-0.1-0.3-0.1c-0.2,0-0.3-0.1-0.2,0l-0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0h-0.1c0,0.1,0.1,0.2,0.3,0.2l0,0c0.1,0.1,0.3,0,0.4,0.1c0-0.1,0.2,0,0.3-0.1 C232.7,157.7,232.6,157.7,232.6,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.7,157.8l0.1-0.1l0,0C232.8,157.8,232.5,157.8,232.7,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.5,161.1c-0.1,0-0.2-0.1-0.3-0.1C222.3,161.1,222.4,161.1,222.5,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.2,158L231.2,158c-0.1-0.1-0.4,0-0.2,0.1C231.1,158,231,157.9,231.2,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.8,161.5c-0.1,0-0.3-0.1-0.4-0.1l0,0c0,0-0.1,0.1-0.1,0c0.1,0,0.2,0,0.2,0.1v0.1 C221.6,161.5,221.8,161.7,221.8,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.2,157.4c0.1,0,0.2,0.1,0.3,0C232.5,157.5,232.3,157.3,232.2,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.3,158.7h-0.2l0.1,0.1c0.1,0,0.2,0.1,0.3,0v-0.1H229.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.4,159.8h0.1c-0.1,0,0,0.1,0.1,0.1h0.2C226.7,159.9,226.6,159.8,226.4,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.8,159.8h-0.1C226.8,159.8,226.8,159.9,226.8,159.8l0.1,0.1C226.9,159.8,226.9,159.8,226.8,159.8 L226.8,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.3,161.1h0.2l-0.1-0.1h0.1C223.4,161,223.4,161,223.3,161.1h0.1C223.3,161.1,223.3,160.9,223.3,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.4,157.9l0.1,0.1L231.4,157.9c0,0.2,0.2,0.1,0.3,0.1C231.5,158,231.5,157.9,231.4,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.7,160.1c0,0.1-0.1,0-0.1,0v-0.1c-0.1,0-0.2,0-0.2-0.1c0,0.1,0,0.1-0.1,0.1l0,0c0,0.1,0,0,0.1,0 c0.1,0-0.1,0.1,0,0.1c0.1,0,0.2,0,0.3,0.1c0,0-0.1-0.1,0.1,0c0.1,0,0.1,0,0.1,0.1v0h-0.1l0.2,0.1c0.1,0,0.1-0.1,0-0.1h0.1 C227,160.2,226.8,160.2,226.7,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.4,158.1h-0.2v0.1l0,0L231.4,158.1C231.3,158.2,231.3,158.1,231.4,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.7,159.7c0,0,0.2,0,0.1-0.1h-0.2c-0.1,0,0.1,0.1,0,0.1H227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.1,160.5C225.2,160.6,225.2,160.5,225.1,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.6,161.1l-0.1-0.1h-0.1c0,0.1,0.3,0.1,0.4,0.1H223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.1,157.5h-0.4l0.1,0.1C232.9,157.5,233,157.6,233.1,157.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "233.1,157.3 233,157.4 233.1,157.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.3,158c0-0.1,0.1,0,0.1,0l-0.3-0.1L232.3,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.1,160.9L225.1,160.9C225,160.8,225.1,160.8,225.1,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.8,161.5L222.8,161.5c0.1,0,0.1,0,0.2,0.1C222.9,161.6,222.9,161.5,222.8,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.9,160.8v0.1C226.1,160.9,225.9,160.8,225.9,160.8c-0.1,0-0.1,0-0.1-0.1v0v0.1H225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.8,160.9L225.8,160.9l-0.2-0.1C225.6,160.9,225.7,160.9,225.8,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.8,161.4c0.2,0.1,0.4,0,0.5,0.1l0,0c-0.1,0,0-0.1-0.1-0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0,0.1,0.1,0.1v-0.1 l0,0l-0.4-0.1c-0.1,0,0,0.1,0,0.1C224.1,161.5,224,161.4,223.8,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.1,158.1c0.1,0,0-0.1,0.1-0.1C233,158,232.9,158.1,233.1,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.8,159.1c0.1,0-0.1,0.1,0,0.1s0.1-0.1,0.1,0C230.9,159.1,230.8,159.1,230.8,159.1L230.8,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.9,161.2c0.1,0,0,0.1,0.2,0.1C225.9,161.3,226.1,161.2,225.9,161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,139.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.1,138.6l-0.1,0.1C212.1,138.8,212.1,138.7,212.1,138.6C212.1,138.6,212.1,138.6,212.1,138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.3,139.2L212.3,139.2C212.4,139.1,212.2,139.2,212.3,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.4,138.8h0.1c0,0.1-0.1,0.2-0.1,0.3l-0.1,0.1l0,0c0-0.1,0.1-0.1,0.1-0.2l0.1-0.4h-0.3 c-0.1,0.1-0.1,0.1-0.1,0.2H212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.6,139.7L211.6,139.7L211.6,139.7l0.1,0.1h0.1c0.1-0.1-0.1-0.1,0-0.2L211.6,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.4,137.5v0.2h0.1c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1-0.1,0.1-0.2,0l0.1-0.1h-0.1l0.1-0.1 c-0.1,0,0.1-0.1-0.1,0c0.1-0.1,0-0.3,0.2-0.3v-0.2l0.1-0.2c-0.1,0.1-0.3,0.2-0.3,0.4l0.1-0.1l-0.1,0.3l0,0 c-0.1,0.2-0.2,0.2-0.2,0.3l0,0l-0.1,0.2l0,0c-0.1,0,0,0.2-0.1,0.2l0,0v-0.1l0.1,0.1c-0.1,0.1-0.2,0.2-0.1,0.3h-0.1l-0.1,0.2h0.1 l-0.2,0.2c0.1,0,0.1,0.1,0.1,0.2l0,0l-0.1,0.1l0.1,0.1c0,0,0,0.1-0.1,0c0,0.1,0,0.1-0.1,0.2l0,0c0,0.1,0,0.1-0.1,0.1l0,0l0.1,0.1 h0.1c0.1,0.1-0.1,0.2,0,0.3c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0c-0.1,0.2,0.1,0.3,0,0.5h0.1l-0.2,0.2v-0.1c0-0.1,0.2-0.2,0.1-0.3 h-0.1c-0.1,0,0,0.3-0.1,0.3s0.1-0.1,0.1,0c0,0.1-0.1-0.1-0.1,0.1v-0.2c0-0.1-0.2-0.1-0.2-0.2l0.1-0.2c-0.1,0.1-0.1-0.2-0.2-0.1 c0.1,0.1,0,0.1-0.1,0.2h0.1v0.5c0.1,0,0,0.2,0.1,0.1l-0.1,0.1v0.1c0.1,0.1,0.1-0.2,0.1-0.2h-0.1c0.2,0,0.3-0.5,0.4-0.4 c-0.2,0.1-0.1,0.4-0.3,0.5l0.1,0.1l-0.1,0.1c0,0-0.1-0.1-0.1,0h0.1c0,0.1,0,0.1-0.1,0.1l0,0h-0.1v0.2l0,0v0.1l-0.2,0.1v0.1 l-0.1,0.2l0,0c-0.1,0.1,0.1,0.2,0,0.2c-0.1,0-0.1,0.1-0.2,0.1v0.6h-0.1v-0.1c-0.1,0,0,0.2-0.1,0.1v-0.1l0.1-0.1l-0.1-0.1v0.2 l-0.2,0.2l0.1,0.1l0.1-0.1h0.1c-0.1,0,0,0.2,0,0.2c0.1-0.1,0.1-0.1,0-0.2c0,0,0,0,0,0l0,0v0.4c0-0.1,0.1,0,0.1-0.2v0.1 c0,0.1,0,0.2-0.1,0.3l0.1,0.2c0,0.2-0.1,0.4-0.1,0.7c-0.1-0.1,0.1-0.2,0-0.3v0.1l0.1,0.1v0.1c0,0.2,0.1,0.2,0.1,0.4h-0.1v0.3h0.1 c0,0.1-0.1,0.2-0.1,0.3c0-0.1,0.1-0.2,0.1-0.1v0.1c0.1,0,0.1,0.2,0.1,0.3s0,0.2,0,0.1c0.1,0.2,0.1,0.3,0.1,0.5c0,0.1-0.1,0-0.1-0.1 v0.1h0.2v0.2l0.1,0.1v-0.1c-0.1,0-0.1-0.2-0.2-0.2s0.1-0.2,0.1-0.3v0.1c0-0.2-0.1-0.4-0.1-0.6c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0 c0-0.1-0.1-0.2,0-0.3c-0.1,0-0.1-0.1-0.2-0.2c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0.1,0.4l0,0l0.1-0.1h-0.1 c0-0.2,0.1-0.1,0.1-0.1h-0.1c0-0.1,0.1-0.2,0.1-0.4h0.1c-0.1,0.1,0,0.3,0,0.5c0-0.1,0.1-0.1,0.2-0.1V145l-0.1,0.2 c0-0.1,0.1-0.1,0-0.2c0.1,0.1,0.1-0.1,0.2-0.1c0-0.2,0-0.5,0.1-0.7l0.1-0.1c0,0.1,0,0.2-0.1,0.3l0,0c0,0.1,0,0.2-0.1,0.3l0.1,0.1 c-0.1,0,0,0.2-0.1,0.2c0,0.2,0.2,0,0.2,0.2v0.4l0,0v0.2c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0-0.2l0.1-0.1c-0.1,0,0-0.1,0-0.2l0,0 c0.1,0,0.1-0.2,0.1-0.3l-0.1-0.1h0.1v-0.2c-0.1-0.1-0.1-0.2-0.1-0.3l0.1-0.1c0.1,0,0.1,0,0.1,0.1c0,0,0,0,0,0v0.1h0.1v0.2l0.2-0.1 v-0.3c0.1-0.2,0-0.4,0-0.5l0.1-0.1v-0.3c0-0.1,0-0.2-0.1-0.3h0.1c-0.1,0,0-0.1,0.1-0.2c0.1-0.1-0.1,0-0.1-0.1l-0.1,0.2v-0.3h-0.1 c0,0.1,0,0.2-0.1,0.2v-0.2l0,0l0.1-0.1c0,0.1,0,0-0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0v-0.3h-0.1v-0.2c0.1-0.1,0-0.1,0-0.3 c0.1,0,0.1,0.1,0.1,0.2c0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1,0,0,0.1h0.1c0-0.1,0-0.2,0.1-0.2s0.1,0,0.1-0.1c0-0.1,0-0.2,0.1-0.2h0.1 v-0.1l0.1-0.1c-0.1,0,0-0.1,0-0.2c0,0.1-0.1,0.1-0.1,0c0,0.2-0.1,0.4-0.2,0.4c-0.1,0,0-0.4,0.1-0.4l0.1-0.1c0,0-0.1-0.2-0.2-0.1 v-0.2l0.1-0.1h0.1v-0.1c0.1,0,0.1,0,0.2,0.1c0.1,0.1-0.1,0.1-0.1,0v0.1l-0.1,0.1l0,0l-0.1,0.2l0.1-0.1v0.1h0.1v0.3 c0.1-0.3,0.1-0.7,0.3-0.9c0,0-0.2,0.1-0.2,0l0,0c-0.1,0.1-0.1,0-0.1,0l0.1-0.2h0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0l-0.1,0.1l0,0 l-0.1,0.1l0,0c0-0.1,0-0.1-0.1-0.1l0,0l-0.1,0.1v0.1l-0.1,0.1h-0.1c0.1,0,0.1-0.2,0.2-0.3H211v-0.1c0.1,0,0.2-0.1,0.3-0.1 s-0.1,0.2-0.1,0.2s0.1-0.2,0.2-0.2s0.1,0,0-0.1h0.1c0,0.1,0,0.1-0.1,0.2h0.1v0.1c0-0.1,0.1-0.1,0.1,0c0-0.1,0-0.1,0.1-0.1l0,0l0,0 c0.1-0.1,0-0.1,0.1-0.1c0.1,0,0.1-0.1,0.1,0h-0.1l0.1-0.2c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0v-0.2l0,0c0.1-0.1,0.2-0.2,0.2-0.3v0.1 l-0.1,0.1h0.1v0.1l0,0c0.1-0.1,0.1-0.2,0.2-0.3h-0.2l-0.2-0.1v0.2l-0.3,0.2l0.1,0.1c0,0.1,0,0.1-0.1,0.1l0,0v0.2l-0.2,0.1l-0.3-0.1 l-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1h-0.1c0-0.1,0.1-0.2,0.1-0.3l-0.1,0.2l-0.1-0.1l0.1-0.1v-0.3h0.2c0-0.1,0-0.1-0.1-0.2l0.2-0.2 l0.2-0.1c0-0.1,0.1-0.2,0.1-0.3L211.4,137.5c0.1,0.1,0.1-0.1,0.1-0.2l0.2-0.3l0.2-0.2l-0.1-0.1l0.3,0.2v-0.1 c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.3c-0.1,0-0.1,0-0.2,0.1h0.1c0,0.1-0.1,0.1-0.1,0.2l-0.1,0.1l0.1-0.1l-0.2,0.2v-0.2 c0-0.1,0.1-0.2,0-0.2s0,0.1,0,0.1h-0.1c-0.1,0.1-0.1,0.2-0.2,0.3h-0.1c-0.1,0,0,0,0,0.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0l0.1,0.1 c0,0.1,0,0.1-0.1,0.2v-0.1l-0.1,0.1l0,0l-0.1,0.2L211.4,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.2,82.6c0,0.1,1.5,7,1.5,7h15.8c-1.8-6.2-3.7-12.3-5.6-18.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M251.1,84.2c2,0.7,4.2,0.9,6.3,0.4c2.5-0.6,4.8-2,6.5-4c1.6-1.7,3.4-3.5,5.1-5.2l2.8-0.6c1-2.1,1.9-4.4,3-6.5 c0.1-0.3,0.2-0.7,0.2-1c0.5-4-2.2-7.1-2.7-7.6c-2.2-2.4-5.1-3.9-8.4-4.2c-1.9-0.2-3.8,0-5.6,0.5l-9.8,2.9l0,0 c-0.2,0.1-0.4,0.1-0.6,0.2c-2.2,0.9-3.1,3.4-3.5,4.4C242.9,67.5,243.2,81.1,251.1,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.9,65c0,1.7-0.6,3.4-1.6,4.7c-0.7,0.9-1.6,1.6-2.7,2c1,0.7,2.1,1.4,3.3,1.9c0.8,0.4,1.6,0.7,2.4,0.9l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.4,71.5l-4.4,0.7l2.8-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.4,73.6c-0.3,0.8-0.7,1.5-1.3,2.1c-0.6,0.5-1.2,1-1.9,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,69.5L246.6,69.5c0.5-0.1,0.7-0.4,0.6-0.8v-0.1c-0.1-0.4-0.4-0.6-0.8-0.6h-0.1c-0.4,0.1-0.6,0.4-0.6,0.8v0.1 C245.9,69.3,246.2,69.6,246.6,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.2,80.7c-0.4,0.4-0.8,0.9-1.4,1.5c-0.4,0.4-0.9,0.8-1.4,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.3,67.9c0,0-3.7-3.5-5.6,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4,58.7c0.4,0.6,0.8,1.1,1.3,1.6c2.1,2.2,4.7,3.8,7.6,4.7c1.7,0.6,3.6,0.9,5.4,0.7c0.4,0,0.8-0.1,1.2-0.2 c3.2-0.5,3.9-1.3,5.2-1.2c2,0.2,3.3,2.7,3.4,2.9c1,2.1,0.7,4.5-0.8,6.2c-0.8,0.9-1.7,1.5-2.9,1.8l4.4,0.3c1.2-2.6,1.9-5.3,2-8.2 v-0.2c0.5-6.3-4.2-11.8-10.6-12.3c-1.4-0.1-2.7,0-4,0.4C256.6,56.4,252.5,57.6,248.4,58.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.3,
    cy: 56,
    rx: 7.7,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Parts_of_bike-2",
    className: "st0",
    x1: 215.9,
    y1: 203.3,
    x2: 347.3,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,74.9c0,0,18.5-5.5,24.1-14.4c0,0-7.8-3.1-14.3-0.7C94.1,63.4,94.4,74.9,94.4,74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.6,55.2c0,0,5.3,8.5,14.6,12.2c1.5-2.8,1.2-6.2-0.9-8.6C271,54.9,265.5,53.4,260.6,55.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.5e371cbec0b55e57d023dca335ca66a7.svg";
export { ForwardRef as ReactComponent };